import axios from "axios";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../utils/TableCustomStyles";
import { containerTableCustomStyles } from "../../utils/TableCustomStyles";
import PlaceholderPicture from "../../images/placeholder-profile.png";
import { Stepper, Step } from 'react-form-stepper';
import "../../components/css/StepperForm.css";
import { format } from "date-fns";
import Select from "react-select";
import Accordion from 'react-bootstrap/Accordion';

function Container() {
  const steps = ['Primary Details', 'Transactional Details', 'Other Details'];
  const [activeStep, setActiveStep] = useState(0);
  const [isOn, setIsOn] = useState(false);
  const [filters, setFilters] = useState({ container_number: '' });

  const addform = useRef(null);
  const addUploadsform = useRef(null);
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [containerNumberList, setContainerNumberList] = useState([]);
  const [containerNumberListCopy, setContainerNumberListCopy] = useState([]);
  const [containerHistoryData, setContainerHistoryData] = useState([]);

  const [customerList, setCustomerList] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [principalList, setPrincipalList] = useState([]);
  const [portList, setPortList] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [depotList, setDepotList] = useState([]);

  const [dataPending, setDataPending] = useState(true);
  const [containerHistoryDataPending, setContainerHistoryDataPending] = useState(true);

  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage['userrole']
  const user_id = sessionStorage['id']
  const [loggedInUser, setLoggedInUser] = useState(null);

  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasFullScreen, setCanvasFullScreen] = useState(false);

  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  const [showDeleteUploadFilesLoader, setShowDeleteUploadFilesLoader] = useState(false);
  const [deleteContainerUploadModal, setDeleteContainerUploadModal] = useState(false);
  const [uploadFilesSerialNumber, setUploadFilesSerialNumber] = useState("");
  const [deleteUploadFileName, setDeleteUploadFileName] = useState("");

  const [recordForDelete, setRecordForDelete] = useState(null);

  const [showContainerNumberError, setShowContainerNumberError] = useState(false);
  const [showTypeError, setShowTypeError] = useState(false);
  const [showPrincipalError, setShowPrincipalError] = useState(false);
  const [showOwnershipError, setShowOwnershipError] = useState(false);
  const [showOwnerError, setShowOwnerError] = useState(false);
  const [showStatusDateError, setShowStatusDateError] = useState(false);
  const [showBookingNumberError, setShowBookingNumberError] = useState(false);
  const [showCurrentLocationError, setShowCurrentLocationError] = useState(false);
  const [showCurrentDepotError, setShowCurrentDepotError] = useState(false);
  const [showCurrentAgentError, setShowCurrentAgentError] = useState(false);
  const [showPurchasedFromError, setShowPurchasedFromError] = useState(false);
  const [showPurchasedPriceError, setShowPurchasedPriceError] = useState(false);
  const [showPurchasedDateError, setShowPurchasedDateError] = useState(false);
  const [showPurchaseAgentError, setShowPurchaseAgentError] = useState(false);
  const [showPurchasedAtError, setShowPurchasedAtError] = useState(false);
  const [showSoldToError, setShowSoldToError] = useState(false);
  const [showSalePriceError, setShowSalePriceError] = useState(false);
  const [showSoldAtError, setShowSoldAtError] = useState(false);
  const [showSaleDateError, setShowSaleDateError] = useState(false);
  const [showCSCApprovalNumberError, setShowCSCApprovalNumberError] = useState(false);
  const [showGrossWeightError, setShowGrossWeightError] = useState(false);
  const [showTareWeightError, setShowTareWeightError] = useState(false);
  const [showPayloadOffWeightError, setShowPayloadOffWeightError] = useState(false);
  const [showManufacturedOnError, setShowManufacturedOnError] = useState(false);


  const [showUpdateContainerNumberError, setShowUpdateContainerNumberError] = useState(false);
  const [showUpdateTypeError, setShowUpdateTypeError] = useState(false);
  const [showUpdatePrincipalError, setShowUpdatePrincipalError] = useState(false);
  const [showUpdateOwnerError, setShowUpdateOwnerError] = useState(false);
  const [showUpdateStatusDateError, setShowUpdateStatusDateError] = useState(false);
  const [showUpdateBookingNumberError, setShowUpdateBookingNumberError] = useState(false);
  const [showUpdateCurrentLocationError, setShowUpdateCurrentLocationError] = useState(false);
  const [showUpdateCurrentDepotError, setShowUpdateCurrentDepotError] = useState(false);
  const [showUpdateCurrentAgentError, setShowUpdateCurrentAgentError] = useState(false);
  const [showUpdatePurchasedFromError, setShowUpdatePurchasedFromError] = useState(false);
  const [showUpdatePurchasedPriceError, setShowUpdatePurchasedPriceError] = useState(false);
  const [showUpdatePurchasedDateError, setShowUpdatePurchasedDateError] = useState(false);
  const [showUpdatePurchaseAgentError, setShowUpdatePurchaseAgentError] = useState(false);
  const [showUpdatePurchasedAtError, setShowUpdatePurchasedAtError] = useState(false);
  const [showUpdateSoldToError, setShowUpdateSoldToError] = useState(false);
  const [showUpdateSalePriceError, setShowUpdateSalePriceError] = useState(false);
  const [showUpdateSoldAtError, setShowUpdateSoldAtError] = useState(false);
  const [showUpdateSaleDateError, setShowUpdateSaleDateError] = useState(false);
  const [showUpdateCSCApprovalNumberError, setShowUpdateCSCApprovalNumberError] = useState(false);
  const [showUpdateGrossWeightError, setShowUpdateGrossWeightError] = useState(false);
  const [showUpdateTareWeightError, setShowUpdateTareWeightError] = useState(false);
  const [showUpdatePayloadOffWeightError, setShowUpdatePayloadOffWeightError] = useState(false);
  const [showUpdateManufacturedOnError, setShowUpdateManufacturedOnError] = useState(false);

  const [showContainerDetails, setShowContainerDetails] = useState(true);
  const [showContainerUploads, setShowContainerUploads] = useState(false);
  const [showContainerHistory, setShowContainerHistory] = useState(false);
  const [showContainerSaleApprove, setShowContainerSaleApprove] = useState(false);

  const [showUploadFilesLoader, setShowUploadFilesLoader] = useState(false);

  const [uploadFileNames, setUploadFileNames] = useState([]);
  const [uploadFiles, setUploadFiles] = useState([]);

  const [containerUploads, setContainerUploads] = useState([]);
  const [containerUploadDataPending, setContainerUploadDataPending] = useState(false);

  // ------------------------ Add Container Form --------------------
  const [containerId, setContainerId] = useState("");
  const [containerNumber, setContainerNumber] = useState("");
  const [containerNumberSelected, setContainerNumberSelected] = useState("");
  const [type, setType] = useState("");
  const [principal, setPrincipal] = useState("");
  const [status, setStatus] = useState("NONE");
  const [ownership, setOwnership] = useState("NONE");
  const [owner, setOwner] = useState("");
  const [grade, setGrade] = useState("NONE");
  const [statusDate, setStatusDate] = useState("");
  const [bookingNumber, setBookingNumber] = useState("");
  const [currentLocation, setCurrentLocation] = useState("");
  const [currentDepot, setCurrentDepot] = useState("");
  const [currentAgent, setCurrentAgent] = useState("");
  const [purchasedFrom, setPurchasedFrom] = useState("");
  const [purchasedPrice, setPurchasedPrice] = useState("");
  const [purchasedDate, setPurchasedDate] = useState("");
  const [purchaseAgent, setPurchaseAgent] = useState("");
  const [purchasedAt, setPurchasedAt] = useState("");
  const [declarationType, setDeclarationType] = useState("NONE");
  const [abundantType, setAbundantType] = useState("NONE");
  const [soldTo, setSoldTo] = useState(null);
  const [soldAt, setSoldAt] = useState(null);
  const [salePrice, setSalePrice] = useState(0.0);
  const [saleDate, setSaleDate] = useState(null);
  const [salePriceBy, setSalePriceBy] = useState("");
  const [approvedSalePrice, setApprovedSalePrice] = useState(0.0);
  const [approvedSalePriceDate, setApprovedSalePriceDate] = useState(null);
  const [approvedSalePriceBy, setApprovedSalePriceBy] = useState("");
  const [cSCApprovalNumber, setCSCApprovalNumber] = useState("");
  const [grossWeight, setGrossWeight] = useState(0.0);
  const [tareWeight, setTareWeight] = useState(0.0);
  const [panelThickness, setPanelThickness] = useState(0.0);
  const [payloadOffWeight, setPayloadOffWeight] = useState(0.0);
  const [manufacturedOn, setManufacturedOn] = useState(null);
  const [notes, setNotes] = useState("");

  // ------------------------ Update Container Form -----------------------
  const [updateId, setUpdateId] = useState("");
  const [updateContainerNumber, setUpdateContainerNumber] = useState("");
  const [updateType, setUpdateType] = useState("");
  const [updatePrincipal, setUpdatePrincipal] = useState("");
  const [updateStatus, setUpdateStatus] = useState("NONE");
  const [updateOwnership, setUpdateOwnership] = useState("NONE");
  const [updateOwner, setUpdateOwner] = useState("");
  const [updateGrade, setUpdateGrade] = useState("NONE");
  const [updateStatusDate, setUpdateStatusDate] = useState("");
  const [updateBookingNumber, setUpdateBookingNumber] = useState("");
  const [updateCurrentLocation, setUpdateCurrentLocation] = useState("");
  const [updateCurrentDepot, setUpdateCurrentDepot] = useState("");
  const [updateCurrentAgent, setUpdateCurrentAgent] = useState("");
  const [updatePurchasedFrom, setUpdatePurchasedFrom] = useState("");
  const [updatePurchasedPrice, setUpdatePurchasedPrice] = useState("");
  const [updatePurchasedDate, setUpdatePurchasedDate] = useState("");
  const [updatePurchaseAgent, setUpdatePurchaseAgent] = useState("");
  const [updatePurchasedAt, setUpdatePurchasedAt] = useState("");
  const [updateDeclarationType, setUpdateDeclarationType] = useState("NONE");
  const [updateAbundantType, setUpdateAbundantType] = useState("NONE");
  const [updateSoldTo, setUpdateSoldTo] = useState("");
  const [updateSoldAt, setUpdateSoldAt] = useState("");
  const [updateSalePrice, setUpdateSalePrice] = useState("");
  const [updateSaleDate, setUpdateSaleDate] = useState("");
  const [updateSalePriceBy, setUpdateSalePriceBy] = useState("");
  const [updateApprovedSalePrice, setUpdateApprovedSalePrice] = useState("");
  const [updateApprovedSalePriceDate, setUpdateApprovedSalePriceDate] = useState("");
  const [updateApprovedSalePriceBy, setUpdateApprovedSalePriceBy] = useState("");
  const [updateCSCApprovalNumber, setUpdateCSCApprovalNumber] = useState("");
  const [updateGrossWeight, setUpdateGrossWeight] = useState("");
  const [updateTareWeight, setUpdateTareWeight] = useState("");
  const [updatePanelThickness, setUpdatePanelThickness] = useState("");
  const [updatePayloadOffWeight, setUpdatePayloadOffWeight] = useState("");
  const [updateManufacturedOn, setUpdateManufacturedOn] = useState("");
  const [updateNotes, setUpdateNotes] = useState("");


  // ----------------------------- History -----------------------------------------
  const [cargoList, setCargoList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [historyDamagedPartList, setHistoryDamagedPartList] = useState([]);

  const [showHistoryContainerNumberError, setShowHistoryContainerNumberError] = useState(false);
  const [showHistoryTypeError, setShowHistoryTypeError] = useState(false);
  const [showHistoryDepotDateError, setShowHistoryDepotDateError] = useState(false);
  const [showHistoryCargoError, setShowHistoryCargoError] = useState(false);
  const [showHistoryCurrencyError, setShowHistoryCurrencyError] = useState(false);
  const [showHistoryBookingNumberError, setShowHistoryBookingNumberError] = useState(false);
  const [showHistoryEstimatedAmountError, setShowHistoryEstimatedAmountError] = useState(false);
  const [showHistoryEstimatedByError, setShowHistoryEstimatedByError] = useState(false);
  const [showHistoryEstimatedDateError, setShowHistoryEstimatedDateError] = useState(false);
  const [showHistoryApprovedAmountError, setShowHistoryApprovedAmountError] = useState(false);
  const [showHistoryApprovedByError, setShowHistoryApprovedByError] = useState(false);
  const [showHistoryApprovalDateError, setShowHistoryApprovalDateError] = useState(false);
  const [showHistoryRepairMarkedByError, setShowHistoryRepairMarkedByError] = useState(false);
  const [showHistoryRepairDateError, setShowHistoryRepairDateError] = useState(false);
  const [showHistoryVerifiedByError, setShowHistoryVerifiedByError] = useState(false);
  const [showHistoryVerificationDateError, setShowHistoryVerificationDateError] = useState(false);


  const [historyContainerNumber, setHistoryContainerNumber] = useState("");
  const [historyStatus, setHistoryStatus] = useState("");
  const [historyGrade, setHistoryGrade] = useState("");
  const [historyType, setHistoryType] = useState("");
  const [historyDepotDate, setHistoryDepotDate] = useState("");
  const [historyCargo, setHistoryCargo] = useState("");
  const [historyCurrency, setHistoryCurrency] = useState("");
  const [historyBookingNumber, setHistoryBookingNumber] = useState("");
  const [historyEstimatedAmount, setHistoryEstimatedAmount] = useState("");
  const [historyEstimatedBy, setHistoryEstimatedBy] = useState("");
  const [historyEstimatedDate, setHistoryEstimatedDate] = useState("");
  const [historyEstimateNotes, setHistoryEstimateNotes] = useState("");
  const [historyApprovedAmount, setHistoryApprovedAmount] = useState("");
  const [historyApprovedBy, setHistoryApprovedBy] = useState("");
  const [historyApprovalDate, setHistoryApprovalDate] = useState("");
  const [historyApprovalNotes, setHistoryApprovalNotes] = useState("");
  const [historyRepairMarkedBy, setHistoryRepairMarkedBy] = useState("");
  const [historyRepairDate, setHistoryRepairDate] = useState("");
  const [historyRepairNotes, setHistoryRepairNotes] = useState("");
  const [historyVerifiedBy, setHistoryVerifiedBy] = useState("");
  const [historyVerificationDate, setHistoryVerificationDate] = useState("");
  const [historyVerificationNotes, setHistoryVerificationNotes] = useState("");

  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [showHistoryChatModal, setShowHistoryChatModal] = useState(false);
  const [recordForHistoryUpdate, setRecordForHistoryUpdate] = useState([]);

  // ----------------------------- Damaged Part -----------------------------------------
  const [historyDamagedPartPhotoList, setHistoryDamagedPartPhotoList] = useState([]);
  const [historyRepairedPartPhotoList, setHistoryRepairedPartPhotoList] = useState([]);


  // const [selectedContainerNumberOption, setSelectedContainerNumberOption] = useState(null);
  const [containerNumberExist, setContainerNumberExist] = useState(false);
  const [showValidationError, setShowValidationError] = useState(false);
  const [isValidationErrorVisible, setIsValidationErrorVisible] = useState(false);
  const [validationErrorArray, setValidationErrorArray] = useState([]);
  const [formAsUpdate, setFormAsUpdate] = useState(false);
  const [inputAction, setInputAction] = useState(false);




  const getLoggenInUser = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/user/' + user_id);
      if (response) {
        setLoggedInUser(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  }

  const getContainer = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/inventory/container/');

      setTimeout(() => {
        if (response) {
          setData(response.data)
          setDataPending(false)
        }
      }, 500);

    } catch (err) {
      toast.error("Error in fetching container data! Try again.");
    }
  }

  const getContainerNumber = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/inventory/container/getcontainernumber/');
      if (response) {
        const data = response.data
        const origin_list = (data || []).filter(item => item?.container_number).map(item => ({ value: item.container_number, label: item.container_number, }));
        setContainerNumberList(origin_list)
        setContainerNumberListCopy(origin_list)
      }
    } catch (err) {
      toast.error("Error in fetching container number data! Try again.");
    }
  }

  const getOffHiredContainer = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/inventory/container?status=OFFHIRED');

      setTimeout(() => {
        if (response) {
          setData(response.data)
          setDataPending(false)
        }
      }, 500);

    } catch (err) {
      toast.error("Error in fetching container data! Try again.");
    }
  }

  const getContainerHistory = async (id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/inventory/containerhistory/gethistory?container=' + id);

      setTimeout(() => {
        if (response) {
          setContainerHistoryData(response.data)
          setContainerHistoryDataPending(false)
        }
      }, 500);

    } catch (err) {
      toast.error("Error in fetching container history data! Try again.");
    }
  }

  const getCustomer = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/customer/');
      const customer_data = response.data
      const sorted_data = customer_data.sort((a, b) => a.name - b.name)
      setCustomerList(sorted_data)
    } catch (err) {
      toast.error("Error in fetching customer data! Try again.");
    }
  }

  const getPort = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/port/');
      const port_data = response.data
      const sorted_data = port_data.sort((a, b) => a.name - b.name)
      setPortList(sorted_data)
    } catch (err) {
      toast.error("Error in fetching port data! Try again.");
    }
  }

  const getDepot = async (currentPort) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/depot?port=' + currentPort);
      const depot_data = response.data
      const sorted_data = depot_data.sort((a, b) => a.name - b.name)
      setDepotList(sorted_data)
    } catch (err) {
      toast.error("Error in fetching depot data! Try again.");
    }
  }

  const getAgent = async (currentPort) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/agent?customer_branch__port=' + currentPort);
      const depot_data = response.data
      const sorted_data = depot_data.sort((a, b) => a.name - b.name)
      setAgentList(sorted_data)
    } catch (err) {
      toast.error("Error in fetching agent data! Try again.");
    }
  }

  const getPrincipal = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/principal/');
      const principal_data = response.data
      const sorted_data = principal_data.sort((a, b) => a.name - b.name)
      setPrincipalList(sorted_data)
    } catch (err) {
      toast.error("Error in fetching principal data! Try again.");
    }
  }

  const getOwner = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/owner/');
      const owner_data = response.data
      const sorted_data = owner_data.sort((a, b) => a.name - b.name)
      setOwnerList(sorted_data)
    } catch (err) {
      toast.error("Error in fetching owner data! Try again.");
    }
  }

  const getCargo = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/cargo/');
      if (response) {
        setCargoList(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching cargo data! Try again.");
    }
  }

  const getUser = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/user/');
      if (response) {
        setUserList(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  }

  const getCurrency = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/currency/');
      if (response) {
        setCurrencyList(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  }

  const getHistoryDamagedPart = async (id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/inventory/containerdamagedpart?container_history=' + id);
      console.log("response", response.data)
      if (response) {
        setHistoryDamagedPartList(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching Damaged Part data! Try again.");
    }
  }

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/role/getuserrolepermission?roles=' + roles);

      const role_permissions_array = []
      for (let i = 0; i < response.data?.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array?.length; j++) {
          if (!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])) {
            role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
          }
        }
      }

      if (role_permissions_array) {
        setCurrentUserRolePermissionData(role_permissions_array)
      }

    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  }

  const handleDeleteModalClose = () => {
    setShowDeleteModal(false)
  }

  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true)
    setRecordForDelete(data)
  }

  const getContainerDetails = async (container_number) => {
    try {
      const existing_container = data.filter(item => item.container_number == container_number)
        .map(item => ({
          id: item.id,
          container_number: item.container_number,
          type: item.type,
          principal: item.principal,
          status: item.status,
          ownership: item.ownership,
          owner: item.owner,
          grade: item.grade,
          status_date: item.status_date,
          booking_number: item.booking_number,
          current_location: item.current_location,
          current_depot: item.current_depot,
          current_agent: item.current_agent,
          purchased_from: item.purchased_from,
          purchase_price: item.purchase_price,
          purchase_date: item.purchase_date,
          purchase_agent: item.purchase_agent,
          purchase_at: item.purchase_at,
          declaration_type: item.declaration_type,
          abundant_type: item.abundant_type,
          sold_to: item.sold_to,
          sale_price: item.sale_price,
          sale_price_by: item.sale_price_by,
          sold_at: item.sold_at,
          sale_date: item.sale_date,
          approved_sale_price: item.approved_sale_price,
          approved_sale_price_date: item.approved_sale_price_date,
          approved_sale_price_by: item.approved_sale_price_by,
          csc_approval_number: item.csc_approval_number,
          gross_weight: item.gross_weight,
          tare_weight: item.tare_weight,
          payload_off_weight: item.payload_off_weight,
          manufactured_on: item.manufactured_on,
          notes: item.notes,
        }));

      const response = existing_container[0]

      if (response) {
        const data = response
        setContainerId(data.id)
        setType(data.type)
        setPrincipal(data.principal)
        setStatus(data.status)
        setOwnership(data.ownership)
        setOwner(data.owner)
        setGrade(data.grade)
        setStatusDate(data.status_date)
        setBookingNumber(data.booking_number)
        setCurrentLocation(data.current_location)
        setCurrentDepot(data.current_depot)
        setCurrentAgent(data.current_agent)
        setPurchasedFrom(data.purchased_from)
        setPurchasedPrice(data.purchase_price)
        setPurchasedDate(data.purchase_date)
        setPurchaseAgent(data.purchase_agent)
        setPurchasedAt(data.purchase_at)
        setDeclarationType(data.declaration_type)
        setAbundantType(data.abundant_type)
        setSoldTo(data.sold_to)
        setSalePrice(data.sale_price)
        setSalePriceBy(data.sale_price_by)
        setSoldAt(data.sold_at)
        setSaleDate(data.sale_date)
        setApprovedSalePrice(data.approved_sale_price)
        setApprovedSalePriceDate(data.approved_sale_price_date)
        setApprovedSalePriceBy(data.approved_sale_price_by)
        setCSCApprovalNumber(data.csc_approval_number)
        setGrossWeight(data.gross_weight)
        setTareWeight(data.tare_weight)
        setPanelThickness(data.panel_thickness)
        setPayloadOffWeight(data.payload_off_weight)
        setManufacturedOn(data.manufactured_on)
        setNotes(data.notes)
      }
      else {
        setType("")
        setPrincipal("")
        setStatus("NONE")
        setOwnership("NONE")
        setOwner("")
        setGrade("NONE")
        setStatusDate("")
        setBookingNumber("")
        setCurrentLocation("")
        setCurrentDepot("")
        setCurrentAgent("")
        setPurchasedFrom("")
        setPurchasedPrice("")
        setPurchasedDate("")
        setPurchaseAgent("")
        setPurchasedAt("")
        setDeclarationType("NONE")
        setAbundantType("NONE")
        setSoldTo(null)
        setSalePrice(0.0)
        setSalePriceBy("")
        setSoldAt(null)
        setSaleDate(null)
        setApprovedSalePrice(0.0)
        setApprovedSalePriceDate(null)
        setApprovedSalePriceBy("")
        setCSCApprovalNumber("")
        setGrossWeight(0.0)
        setTareWeight(0.0)
        setPayloadOffWeight(0.0)
        setManufacturedOn(null)
        setNotes("")
      }
    } catch (err) {
      setType("")
      setPrincipal("")
      setStatus("NONE")
      setOwnership("NONE")
      setOwner(data.owner)
      setGrade("NONE")
      setStatusDate("")
      setBookingNumber("")
      setCurrentLocation("")
      setCurrentDepot("")
      setCurrentAgent("")
      setPurchasedFrom("")
      setPurchasedPrice("")
      setPurchasedDate("")
      setPurchaseAgent("")
      setPurchasedAt("")
      setDeclarationType("NONE")
      setAbundantType("NONE")
      setSoldTo(null)
      setSalePrice(0.0)
      setSalePriceBy("")
      setSoldAt(null)
      setSaleDate(null)
      setApprovedSalePrice(0.0)
      setApprovedSalePriceDate(null)
      setApprovedSalePriceBy("")
      setCSCApprovalNumber("")
      setGrossWeight(0.0)
      setTareWeight(0.0)
      setPayloadOffWeight(0.0)
      setManufacturedOn(null)
      setNotes("")
    }
  }

  const handleSetUpdateData = (row) => {
    setUpdateId(row.id)
    setUpdateContainerNumber(row.container_number)
    setUpdateType(row.type)
    setUpdatePrincipal(row.principal)
    setUpdateStatus(row.status)
    setUpdateOwnership(row.ownership)
    setUpdateOwner(row.owner)
    setUpdateGrade(row.grade)
    setUpdateStatusDate(row.status_date)
    setUpdateBookingNumber(row.booking_number)
    setUpdateCurrentLocation(row.current_location)
    setUpdateCurrentDepot(row.current_depot)
    setUpdateCurrentAgent(row.current_agent)
    setUpdatePurchasedFrom(row.purchased_from)
    setUpdatePurchasedPrice(row.purchase_price)
    setUpdatePurchasedDate(row.purchase_date)
    setUpdatePurchaseAgent(row.purchase_agent)
    setUpdatePurchasedAt(row.purchase_at)
    setUpdateDeclarationType(row.declaration_type)
    setUpdateAbundantType(row.abundant_type)
    setUpdateSoldTo(row.sold_to)
    setUpdateSalePrice(row.sale_price)
    setUpdateSalePriceBy(row.sale_price_by)
    setUpdateSoldAt(row.sold_at)
    setUpdateSaleDate(row.sale_date)
    setUpdateApprovedSalePrice(row.approved_sale_price)
    setUpdateApprovedSalePriceDate(row.approved_sale_price_date)
    setUpdateApprovedSalePriceBy(row.approved_sale_price_by)
    setUpdateCSCApprovalNumber(row.csc_approval_number)
    setUpdateGrossWeight(row.gross_weight)
    setUpdateTareWeight(row.tare_weight)
    setUpdatePanelThickness(row.panel_thickness)
    setUpdatePayloadOffWeight(row.payload_off_weight)
    setUpdateManufacturedOn(row.manufactured_on)
    setUpdateNotes(row.notes)

    if (row.upload_urls?.length < 1) {
      setContainerUploads({})
      setContainerUploadDataPending(false)
    }
    else {
      setContainerUploads(row.upload_urls)
      setContainerUploadDataPending(false)
    }

    getContainerHistory(row.id)
    getUser()
    getCargo()
    getCurrency()
  }

  useEffect(() => {
    getLoggenInUser()
    getContainer()
    getContainerNumber()
    getCustomer()
    getPort()
    getPrincipal()
    getOwner()
  }, []);

  useEffect(() => {
    getDepot(currentLocation)
    getAgent(currentLocation)
  }, [currentLocation]);

  useEffect(() => {
    getCurrentUserRolePermission(user_role)
  }, [user_role]);

  const handleFilterChange = (column, value) => {
    setFilters(prev => ({ ...prev, [column]: value }));
  };

  const filteredData = data.filter(item =>
    Object.keys(filters).every(key => item[key]?.toLowerCase().includes(filters[key].toLowerCase()))
  );

  const columns = [
    {
      name: (
        <div class="form-group">
          <label>Container No.</label>
          <input className="form form-control form-control-sm my-1 w-100"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onChange={e => handleFilterChange('container_number', e.target.value)}
          />
        </div>
      ),
      selector: row => row.container_number,

      sortable: true,
      conditionalCellStyles: [
        {
          when: row => row.declaration_type === "SALE_UNIT",
          style: {
            backgroundColor: "#dc3545",
            color: "#fff",
            fontWeight: "bold",
          },
        },
      ]
    },
    {
      name: (
        <div class="form-group">
          <label>Principal</label>
          <input className="form form-control form-control-sm my-1 w-100"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onChange={e => handleFilterChange('principal__name', e.target.value)}
          />
        </div>
      ),
      selector: row => row.principal__name,
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Type</label>
          <input className="form form-control form-control-sm my-1 w-100"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onChange={e => handleFilterChange('type', e.target.value)}
          />
        </div>
      ),
      selector: row => row.type == "HD20" ? "20HD" :
        row.type == "HD40" ? "40HD" :
          row.type == "GP20" ? "20GP" :
            row.type == "GP40" ? "40GP" :
              "40HQ",
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Grade</label>
          <input className="form form-control form-control-sm my-1 w-100"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onChange={e => handleFilterChange('grade', e.target.value)}
          />
        </div>
      ),
      selector: row => row.grade,
      width: '140px',
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Booking No.</label>
          <input className="form form-control form-control-sm my-1 w-100"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onChange={e => handleFilterChange('booking_number', e.target.value)}
          />
        </div>
      ),
      width: '150px',
      selector: row => row.booking_number,
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Current Location</label>
          <input className="form form-control form-control-sm my-1 w-100"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onChange={e => handleFilterChange('current_location__name', e.target.value)}
          />
        </div>
      ),
      selector: row => row.current_location__name,
      width: '200px',
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Current Depot</label>
          <input className="form form-control form-control-sm my-1 w-100"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onChange={e => handleFilterChange('current_depot__name', e.target.value)}
          />
        </div>
      ),
      selector: row => row.current_depot__name,
      width: '200px',
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Current Agent</label>
          <input className="form form-control form-control-sm my-1 w-100"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onChange={e => handleFilterChange('current_agent__name', e.target.value)}
          />
        </div>
      ),
      selector: row => row.current_agent__name,
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Current Owner</label>
          <input className="form form-control form-control-sm my-1 w-100"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onChange={e => handleFilterChange('owner__name', e.target.value)}
          />
        </div>
      ),
      selector: row => row.owner__name,
      sortable: true,
    },
    {
      name: (
        <div class="form-group">
          <label>Status</label>
          <input className="form form-control form-control-sm my-1 w-100"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onChange={e => handleFilterChange('status', e.target.value)}
          />
        </div>
      ),
      selector: row => row.status,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("inventory:container:update") ?
            <Button className="btn btn-sm btn-inox-green border-0" title="Update" data-bs-toggle="offcanvas" data-bs-target="#updateSection" onClick={() => handleSetUpdateData(row)}>
              <i className="fa fa-edit"></i>
            </Button>
            :
            ""
        }

        {
          currentUserRolePermissionData?.includes("inventory:container:delete") ?
            <Button className="btn btn-sm bg-danger border-0 mx-2" title="Delete" onClick={() => handleDeleteModalOpen(row)}>
              <i className="fa fa-trash"></i>
            </Button>
            :
            ""
        }
      </div>,
    }
  ];

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true)
    try {
      await axios.delete(process.env.REACT_APP_BACKEND_API_URL + '/inventory/container/' + id + '/');
      setShowDeleteModal(false)
      getContainer()
      toast.success("Record deleted successfully")
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    }
    setShowDeleteLoader(false)
  }

  const resetAddForm = () => {
    setContainerNumber("")
    setContainerNumberSelected("")
    setType("")
    setPrincipal("")
    setStatus("NONE")
    setOwnership("NONE")
    setOwner("")
    setGrade("NONE")
    setStatusDate("")
    setBookingNumber("")
    setCurrentLocation("")
    setCurrentDepot("")
    setCurrentAgent("")
    setPurchasedFrom("")
    setPurchasedPrice("")
    setPurchasedDate("")
    setPurchaseAgent("")
    setPurchasedAt("")
    setDeclarationType("NONE")
    setAbundantType("NONE")
    setSoldTo(null)
    setSalePrice(0.0)
    setSoldAt(null)
    setSaleDate(null)
    setCSCApprovalNumber("")
    setGrossWeight(0.0)
    setTareWeight(0.0)
    setPanelThickness(0.0)
    setPayloadOffWeight(0.0)
    setManufacturedOn(null)
    setNotes("")
  }

  const addNewContainer = async (e) => {
    e.preventDefault();
    setShowAddLoader(true)
    setValidationErrorArray([])

    const validation_error_array = []

    if (containerNumber == "" | containerNumber == "NONE") {
      if (containerNumberSelected?.value == "" | containerNumberSelected?.value == "NONE") {
        validation_error_array.push("Container Number is required")
      }
    }
    if (ownership == "" | ownership == "NONE") {
      validation_error_array.push("Ownership is required")
    }
    if (owner == "" | owner == "NONE") {
      validation_error_array.push("Owner is required")
    }
    if (currentLocation == "" | currentLocation == "NONE") {
      validation_error_array.push("Location is required")
    }
    if (currentDepot == "" | currentDepot == "NONE") {
      validation_error_array.push("Depot is required")
    }
    if (currentAgent == "" | currentAgent == "NONE") {
      validation_error_array.push("Agent is required")
    }
    if (purchasedFrom == "" | purchasedFrom == "NONE") {
      validation_error_array.push("Purchased from is required")
    }
    if (purchasedPrice == "" | purchasedPrice == "NONE") {
      validation_error_array.push("Purchase price is required")
    }
    if (purchasedDate == "" | purchasedDate == "NONE") {
      validation_error_array.push("Purchase date is required")
    }
    if (purchaseAgent == "" | purchaseAgent == "NONE") {
      validation_error_array.push("Purchase Agent is required")
    }
    if (purchasedAt == "" | purchasedAt == "NONE") {
      validation_error_array.push("Purchased at location is required")
    }

    if (validation_error_array.length < 1) {
      setShowValidationError(false)

      const data = {
        container_number: containerNumber ? containerNumber : containerNumberSelected?.value,
        type: type,
        principal: principal,
        status: status,
        ownership: ownership,
        owner: owner,
        grade: grade,
        status_date: statusDate,
        booking_number: bookingNumber,
        current_location: currentLocation,
        current_depot: currentDepot,
        current_agent: currentAgent,
        purchased_from: purchasedFrom,
        purchase_price: purchasedPrice,
        purchase_date: purchasedDate,
        purchase_agent: purchaseAgent,
        purchase_at: purchasedAt,
        declaration_type: declarationType,
        abundant_type: abundantType,
        sold_to: soldTo,
        sale_price: salePrice,
        sale_price_by: salePriceBy,
        sold_at: soldAt,
        sale_date: saleDate,
        approved_sale_price: approvedSalePrice,
        approved_sale_price_date: approvedSalePriceDate,
        approved_sale_price_by: approvedSalePriceBy,
        csc_approval_number: cSCApprovalNumber,
        gross_weight: grossWeight,
        tare_weight: tareWeight,
        panel_thickness: panelThickness,
        payload_off_weight: payloadOffWeight,
        manufactured_on: manufacturedOn,
        notes: notes,
        created_by: JSON.stringify({ "id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type })
      }

      if (!formAsUpdate) {
        const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/inventory/container/', data,
          {
            headers: { 'content-type': 'application/json' }
          }
        );

        if (response.status === 200) {
          toast.success("Container Created Successfully")
          resetAddForm()
        }

        if (response) {
          toast.success("Container Created Successfully")
        }
      }
      else {
        const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/inventory/container/' + containerId + '/', data,
          {
            headers: { 'content-type': 'application/json' }
          }
        );

        if (response) {
          toast.success("Container Updated Successfully")
        }
      }
    }
    else {
      setShowValidationError(true)
      setValidationErrorArray(validation_error_array)
    }

    getContainer()
    setShowAddCanvas(false)
    setShowAddLoader(false)
  }

  const updateContainerDetails = async (e) => {
    e.preventDefault();
    setShowUpdateLoader(true)

    const id = updateId

    // const container_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/inventory/container/' + id)
    // container_data = container_response.data
    // updated_fields = []

    // if(container_data.container_number != updateContainerNumber){
    //   updated_fields.append({"Field": "Container Number", "Value": updateContainerNumber})
    // }

    const data = {
      containerNumber: updateContainerNumber,
      type: updateType,
      principal: updatePrincipal,
      status: updateStatus,
      ownership: updateOwnership,
      owner: updateOwner,
      grade: updateGrade,
      status_date: updateStatusDate,
      booking_number: updateBookingNumber,
      current_location: updateCurrentLocation,
      current_depot: updateCurrentDepot,
      current_agent: updateCurrentAgent,
      purchased_from: updatePurchasedFrom,
      purchase_price: updatePurchasedPrice,
      purchase_date: updatePurchasedDate,
      purchase_agent: updatePurchaseAgent,
      purchase_at: updatePurchasedAt,
      declaration_type: updateDeclarationType,
      abundant_type: updateAbundantType,
      sold_to: updateSoldTo,
      sale_price: updateSalePrice,
      sale_price_by: updateSalePriceBy,
      sold_at: updateSoldAt,
      sale_date: updateSaleDate,
      approved_sale_price: updateApprovedSalePrice,
      approved_sale_price_date: updateApprovedSalePriceDate,
      approved_sale_price_by: updateApprovedSalePriceBy,
      csc_approval_number: updateCSCApprovalNumber,
      gross_weight: updateGrossWeight,
      tare_weight: updateTareWeight,
      payload_off_weight: updatePayloadOffWeight,
      manufactmanufactured_onuredOn: updateManufacturedOn,
      panel_thickness: updatePanelThickness,
      notes: updateNotes,
      modified_by: JSON.stringify({ "id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type })
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/inventory/container/' + id + '/', data,
      {
        headers: { 'content-type': 'application/json' }
      }
    );

    if (response.status === 200) {
      toast.success("Container Updated Successfully")
    }

    // const audit_data = {
    //   activity_by: loggedInUser,
    //   container_id: updateId,
    //   contianer_number: updateContainerNumber,
    //   previous_field: [{"Field": "", "Value": ""}],
    //   action: "UPDATE"
    // }

    // await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/inventory/containeraudit/', audit_data, { headers: { 'content-type': 'application/json' }});

    getContainer()
    setShowUpdateCanvas(false)
    setShowUpdateLoader(false)
  }


  //  ----------------------------------------------- Uploads  -----------------------------------------------------

  const uploadcolumns = [
    {
      name: 'File Name',
      selector: row => row.filename,
      sortable: true,
    },
    // {
    //   name: 'Preview',
    //   selector: row => <img className="img img-thumbnail" src={`${process.env.REACT_APP_BACKEND_API_URL}${row.file_url}`} height={40} width={40}></img>,
    //   sortable: true,
    // },
    {
      name: 'File Type',
      selector: row => row.filetype,
      sortable: true,
    },
    {
      name: 'File Size',
      selector: row => row.filesize + " " + row.fileunit,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("inventory:container:view") ?
            <a href={`${row.file_url}`} target="_blank">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" title="View">
                <i className="fa fa-eye"></i>
              </Button>
            </a>
            :
            ""
        }

        {
          currentUserRolePermissionData?.includes("inventory:container:delete") ?
            <Button className="btn btn-sm bg-danger border-0 mx-2" title="Delete" onClick={() => setDeleteUploadDetails(row)}>
              <i className="fa fa-trash"></i>
            </Button>
            :
            ""
        }
      </div>,
    }
  ];

  const handleUploadsFileChange = (files) => {
    const fileArray = Array.from(files);
    const names = []
    fileArray.map(file => names.push(file?.name));
    setUploadFileNames(names);
  }

  const addContainerUploads = async (e) => {
    e.preventDefault();
    setShowUploadFilesLoader(true)

    const id = updateId

    const data = {
      id: id,
      upload: uploadFiles
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/inventory/container/containeruploads/', data,
      {
        headers: { 'content-type': 'multipart/form-data' }
      }
    );
    if (response.status === 200) {
      toast.success("Files Uploaded Successfully")
    }

    addUploadsform.current.uploads.value = [];
    setContainerUploads(response.data.upload_urls)
    setShowUploadFilesLoader(false)
  }

  const setDeleteUploadDetails = (row) => {
    setDeleteContainerUploadModal(true)
    setUploadFilesSerialNumber(row.serial_number)
    setDeleteUploadFileName(row.filename)
  }

  const deleteContainerUploads = async (e) => {
    e.preventDefault();
    setShowDeleteUploadFilesLoader(true)

    const id = updateId

    const data = {
      id: id,
      serial_number: uploadFilesSerialNumber
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/inventory/container/deletecontaineruploads/', data,
      {
        headers: { 'content-type': 'application/json' }
      }
    );
    if (response.status === 200) {
      toast.success("File Deleted Successfully")
      setContainerUploads(response.data.upload_urls)
    }

    setShowDeleteUploadFilesLoader(false)
    setDeleteContainerUploadModal(false)
  }

  //  ----------------------------------------------- Uploads  -----------------------------------------------------

  //  ----------------------------------------------- Container History  -----------------------------------------------------

  const handleHistoryChatModalClose = () => {
    setShowHistoryChatModal(false)
  }

  const handleHistoryChatModalOpen = (data) => {
    setShowHistoryChatModal(true)
  }

  const handleHistoryModalClose = () => {
    setShowHistoryModal(false)
  }

  const handleHistoryModalOpen = (row) => {
    setShowHistoryModal(true)
    setRecordForHistoryUpdate(row)
    setHistoryContainerNumber(row.container__container_number)
    setHistoryStatus(row.estimated_status)
    setHistoryGrade(row.grade)
    setHistoryType(row.container__type)
    setHistoryDepotDate(format(new Date(row?.pick_date), "yyyy-MM-dd"))
    setHistoryCargo(row.cargo_name)
    setHistoryCurrency(row.currency)
    setHistoryBookingNumber(row.booking_number)
    setHistoryEstimatedAmount(row.estimated_amount)
    setHistoryEstimatedBy(row.estimated_by)
    setHistoryEstimatedDate(format(new Date(row?.estimated_date), "yyyy-MM-dd"))
    setHistoryEstimateNotes(row.estimate_notes)
    setHistoryApprovedAmount(row.approved_amount)
    setHistoryApprovedBy(row.approved_by)
    setHistoryApprovalDate(format(new Date(row?.approval_date), "yyyy-MM-dd"))
    setHistoryApprovalNotes(row.approval_notes)
    setHistoryRepairMarkedBy(row.repair_marked_by)
    setHistoryRepairDate(format(new Date(row?.repair_date), "yyyy-MM-dd"))
    setHistoryRepairNotes(row.repair_notes)
    setHistoryVerifiedBy(row.verified_by)
    setHistoryVerificationDate(format(new Date(row?.verification_date), "yyyy-MM-dd"))
    setHistoryVerificationNotes(row.verification_notes)

    getHistoryDamagedPart(row.id)
  }

  const historycolumns = [
    {
      name: 'Booking No.',
      selector: row => row.booking_number,
      sortable: true,
    },
    {
      name: 'Pick Port',
      selector: row => row.pick_port__name,
      sortable: true,
    },
    {
      name: 'Pick Depot',
      selector: row => row.pick_depot__name,
      sortable: true,
    },
    {
      name: 'Pick Date',
      selector: row => new Date(row.pick_date).toLocaleString(),
      sortable: true,
    },
    {
      name: 'Drop Port',
      selector: row => row.drop_port__name,
      sortable: true,
    },
    {
      name: 'Drop Depot',
      selector: row => row.drop_depot__name,
      sortable: true,
    },
    {
      name: 'Drop Date',
      selector: row => new Date(row.drop_date).toLocaleString(),
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("inventory:containerhistory:view") ?
            <Button className="btn btn-sm btn-inox-green border-0 mx-2" title="View" onClick={() => handleHistoryModalOpen(row)}>
              <i className="fa fa-eye"></i>
            </Button>
            :
            ""
        }

        {
          currentUserRolePermissionData?.includes("inventory:containerhistory:view") ?
            <Button className="btn btn-sm bg-info border-0 mx-2" title="Chat" onClick={() => handleHistoryChatModalOpen(row)}>
              <i className="fa fa-comment"></i>
            </Button>
            :
            ""
        }
      </div>,
    }
  ];
  //  ----------------------------------------------- Container History  -----------------------------------------------------

  //  ----------------------------------------------- Container History Damaged Part  -----------------------------------------------------
  const historydamagedpartcolumns = [
    {
      name: 'Part',
      selector: row => row.part__part_name,
      sortable: true,
    },
    {
      name: 'Damage Description',
      selector: row => row.damage_description,
      sortable: true,
    },
    {
      name: 'Damage Size / Count',
      selector: row => row.damage_size_count,
      sortable: true,
    },
    {
      name: 'Man Hours',
      selector: row => row.man_hours,
      sortable: true,
    },
    {
      name: 'Man Cost',
      selector: row => row.man_cost,
      sortable: true,
    },
    {
      name: 'Material Cost',
      selector: row => row.material_cost,
      sortable: true,
    },
    {
      name: 'Total',
      selector: row => row.total,
      sortable: true,
    },
    {
      name: 'Approved Amount',
      selector: row => row.approved_amount,
      sortable: true,
    },
    {
      name: 'Approver Note',
      selector: row => row.approver_note,
      sortable: true,
    },
    {
      name: 'Verifier Note',
      selector: row => row.verifier_note,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("inventory:containerhistory:view") ?
            <Button className="btn btn-sm btn-inox-green border-0 mx-2" title="View" onClick={() => [handleHistoryDamagedPartPhotos(row), handleHistoryRepairedPartPhotos(row)]}>
              <i className="fa fa-eye"></i>
            </Button>
            :
            ""
        }
      </div>,
    }
  ];
  //  ----------------------------------------------- Container History Damaged Part  -----------------------------------------------------

  //  ----------------------------------------------- Container History Damaged Part Photos-----------------------------------------------------

  const handleHistoryDamagedPartPhotos = async (row) => {
    const damaged_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/inventory/containerdamagedpartpicture?damaged_part=' + row.id);

    if (damaged_response) {
      setHistoryDamagedPartPhotoList(damaged_response.data)
    }
  }

  const handleHistoryRepairedPartPhotos = async (row) => {
    const repaied_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/inventory/containerpostrepairpartpicture?damaged_part=' + row.id);

    if (repaied_response) {
      setHistoryRepairedPartPhotoList(repaied_response.data)
    }
  }

  const historypartphotoscolumns = [
    {
      name: 'Title',
      selector: row => row.title,
      sortable: true,
    },
    {
      name: 'Preview',
      selector: row => <img src={row.file} height={50} />,
      sortable: true,
    },
    {
      name: 'Description',
      selector: row => row.description,
      sortable: true,
    },
    {
      name: 'File Name',
      selector: row => row.file_name,
      sortable: true,
    },
    {
      name: 'File Type',
      selector: row => row.file_type,
      sortable: true,
    },
    {
      name: 'File Size',
      selector: row => row.file_size,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("inventory:container:view") ?
            <a href={`${row.file}`} target="_blank">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" title="View">
                <i className="fa fa-eye">
                </i>
              </Button>
            </a>
            :
            ""
        }
      </div>,
    }
  ];

  //  ----------------------------------------------- Container History Damaged Part Photos-----------------------------------------------------

  const handleToggleStatus = async () => {
    if (isOn) {
      setIsOn(false)
      setDataPending(true)
      getContainer()
    }
    else {
      setIsOn(true)
      setDataPending(true)
      getOffHiredContainer()
    }
  };

  const handleCheckValidationClick = () => {
    setIsValidationErrorVisible(!isValidationErrorVisible);
  };


  const customComponents = {
    DropdownIndicator: () => null, // removes the dropdown arrow
    IndicatorSeparator: () => null, // optional: removes the line separator
  };


  const checkContainerNumberExist = (value) => {
    if (containerNumberListCopy.some(number => number.value.toUpperCase() == value?.toUpperCase())) {
      setFormAsUpdate(true)
      getContainerDetails(value?.toUpperCase())
    }
    else {
      setFormAsUpdate(false)
      getContainerDetails()
    }

  }

  const checkContainerNumberFormat = (number) => {
    const regex = /^[A-Z]{3}U\d{7}$/;
    if (number && !regex.test(number)) {
      setShowContainerNumberError(true);
    } else {
      setShowContainerNumberError(false);
    }
  }


  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <ToastContainer />
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar} />
      <SideNavbar sidebarCollapsed={menuDrawerShow} activeMenu="Inventory" activeSubMenu="Container" activeSubMenuLevel1="" permissionFromTopNavbar={dataFromTopNavBar} />

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"} >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow ?
                  <span><i className="fa fa-chevron-left mx-1"></i></span> :
                  <span><i className="fa fa-chevron-right mx-1"></i></span>
                }
              </Button>
              <span className="page-header-text">
                {isOn ? "OffHired Containers" : "Containers"}
                <label class="switch">
                  <input type="checkbox" onChange={handleToggleStatus} />
                  <span class="slider round"></span>
                </label>
              </span>
              {filteredData.length < 1 ?
                <span className="text-inox-green mx-3 pointer" style={{ verticalAlign: 'middle' }} onClick={() => setFilters("", "")}>
                  Clear Filters
                </span>
                : ""
              }
            </div>

            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {
                currentUserRolePermissionData?.includes("master:customer:add") ?
                  <Button className="btn btn-sm btn-inox-green border-0  px-3 float-right" data-bs-toggle="offcanvas" data-bs-target="#addSection"
                    onClick={() => [setActiveStep(0), resetAddForm()]}>
                    <i className="fa fa-plus fa-lg text-right" style={{ paddingRight: 10 }}></i>
                    <span className="fw-bold">Add Container</span>
                  </Button>
                  :
                  ""
              }
            </div>
          </div>
        </div>

        <div className="col-12 text-left" style={{ paddingLeft: 20, paddingRight: 30, zIndex: 100, marginTop: 5 }}>
          <DataTable
            columns={columns}
            data={filteredData}
            progressPending={dataPending}
            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
            noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
            pagination
            highlightOnHover
            resizable
            fixedHeader
            persistTableHead
            customStyles={containerTableCustomStyles}
            dense
            style={{ marginTop: 100 }}
          />
        </div>
      </div>

      <Modal size="sm" show={showDeleteModal} onHide={handleDeleteModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>Close</Button>
          <Button variant="danger" onClick={() => deleteSelectedRecord(recordForDelete?.id)}>
            {showDeleteLoader ?
              <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
              :
              "Delete"
            }

          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Section ------------------- */}
      <div class={canvasFullScreen && showUpdateCanvas ? "offcanvas offcanvas-bottom h-100 show" :
        !canvasFullScreen && showUpdateCanvas ? "offcanvas offcanvas-bottom h-60 show" : "offcanvas offcanvas-bottom h-60"}
        id="updateSection" data-bs-scroll="true" tabindex="-1" aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Update Record</h4>
              <Button className={`${showContainerDetails ? 'btn-inox-red' : 'btn-inox-green'} border-0 btn-sm`} style={{ marginRight: 10, width: 120 }}
                onClick={() => [setShowContainerDetails(true), setShowContainerUploads(false), setShowContainerHistory(false), setShowContainerSaleApprove(false)]}>
                Details
              </Button>

              <Button className={`${showContainerUploads ? 'btn-inox-red' : 'btn-inox-green'} border-0 btn-sm`} style={{ marginRight: 10, width: 120 }}
                onClick={() => [setShowContainerDetails(false), setShowContainerUploads(true), setShowContainerHistory(false), setShowContainerSaleApprove(false)]}>
                Uploads
              </Button>

              <Button className={`${showContainerHistory ? 'btn-inox-red' : 'btn-inox-green'} border-0 btn-sm`} style={{ marginRight: 10, width: 120 }}
                onClick={() => [setShowContainerDetails(false), setShowContainerUploads(false), setShowContainerHistory(true), setShowContainerSaleApprove(false)]}>
                History
              </Button>

              {updateDeclarationType=="SALE_UNIT"?
              <Button className={`${showContainerSaleApprove ? 'btn-inox-red' : 'btn-inox-green'} border-0 btn-sm`} style={{ marginRight: 10, width: 120 }}
                onClick={() => [setShowContainerDetails(false), setShowContainerUploads(false), setShowContainerHistory(false), setShowContainerSaleApprove(true)]}>
                Sale Approve
              </Button>
              :""}
            </div>
            <div className="col-6">
              <button type="button" class="btn btn-danger btn-sm float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close"
                onClick={() => [setShowUpdateCanvas(false), setShowContainerDetails(true)]}>
                <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen ?
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Half Screen" onClick={() => [setCanvasFullScreen(false), setShowUpdateCanvas(true)]}>
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
                :
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Full Screen" onClick={() => [setCanvasFullScreen(true), setShowUpdateCanvas(true)]}>
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              }
            </div>
          </div>
        </div>

        <div class="offcanvas-body" style={{ paddingLeft: 20, paddingRight: 40 }}>
          <div style={{ display: showContainerDetails ? 'block' : 'none' }}>
            <form onSubmit={(e) => updateContainerDetails(e)}>
              <div className="row">
                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="container_number">Container Number: <i className="text-danger">*</i><span className="text-danger">{showUpdateContainerNumberError ? "Container Number required" : ""}</span></label>
                  <input type="text" class="form-control form-control" id="container_number" name="container_number" placeholder="Enter Container Number"
                    onBlur={(e) => e.target.value == "" ? setShowUpdateContainerNumberError(true) : setShowUpdateContainerNumberError(false)}
                    onChange={(e) => setUpdateContainerNumber(e.target.value)} value={updateContainerNumber} disabled />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="type">Container Type: <i className="text-danger">*</i><span className="text-danger">{showUpdateTypeError ? "Container Type required" : ""}</span></label>
                  <select className="form-select form-select" name="type" onBlur={(e) => e.target.value == "" ? setShowUpdateTypeError(true) : setShowUpdateTypeError(false)}
                    onChange={(e) => setUpdateType(e.target.value)} disabled>
                    <option value="" selected>Select Container Type</option>
                    <option value="GP20" selected={updateType == "GP20" ? true : false}>20 GP</option>
                    <option value="GP40" selected={updateType == "GP40" ? true : false}>20 GP</option>
                    <option value="HD20" selected={updateType == "HD20" ? true : false}>20 HD</option>
                    <option value="HD40" selected={updateType == "HD40" ? true : false}>40 HD</option>
                    <option value="HQ40" selected={updateType == "HQ40" ? true : false}>40 HQ</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="principal">Principal: <i className="text-danger">*</i><span className="text-danger">{showUpdatePrincipalError ? " Principal required" : ""}</span></label>
                  <select className="form-select form-select" name="principal" onBlur={(e) => e.target.value == "" ? setShowUpdatePrincipalError(true) : setShowUpdatePrincipalError(false)}
                    onChange={(e) => setUpdatePrincipal(e.target.value)}>
                    <option value="" selected>Select Principal</option>
                    {principalList.map(principal =>
                      <option value={principal.id} selected={updatePrincipal == principal.id ? true : false}>{principal.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="status">Status: </label>
                  <select className="form-select form-select" name="status" onChange={(e) => setUpdateStatus(e.target.value)}>
                    <option value="EMPTY_AV" selected>Select Status</option>
                    <option value="BOOKED" selected={updateStatus == "BOOKED" ? true : false}>BOOKED</option>
                    <option value="EMPTY_AV" selected={updateStatus == "EMPTY_AV" ? true : false}>EMPTY AV</option>
                    <option value="EMPTY_APPROVED" selected={updateStatus == "EMPTY_APPROVED" ? true : false}>EMPTY APPROVED</option>
                    <option value="EMPTY_ESTIMATED" selected={updateStatus == "EMPTY_ESTIMATED" ? true : false}>EMPTY ESTIMATED</option>
                    <option value="EMPTY_REPAIRED" selected={updateStatus == "EMPTY_REPAIRED" ? true : false}>EMPTY REPAIRED</option>
                    <option value="EMPTY_UNESTIMATED" selected={updateStatus == "EMPTY_UNESTIMATED" ? true : false}>EMPTY UNESTIMATED</option>
                    <option value="EXPORTED" selected={updateStatus == "EXPORTED" ? true : false}>EXPORTED</option>
                    <option value="IMPORT_LADEN" selected={updateStatus == "IMPORT_LADEN" ? true : false}>IMPORT LADEN</option>
                    <option value="LEASED_OUT" selected={updateStatus == "LEASED_OUT" ? true : false}>LEASED OUT</option>
                    <option value="OFFHIRED" selected={updateStatus == "OFFHIRED" ? true : false}>OFFHIRED</option>
                    <option value="ON_THE_WAY" selected={updateStatus == "ON_THE_WAY" ? true : false}>ON THE WAY</option>
                    <option value="PICKED" selected={updateStatus == "PICKED" ? true : false}>PICKED</option>
                    <option value="SOLD_UNIT" selected={updateStatus == "SOLD_UNIT" ? true : false}>SOLD UNIT</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="ownership">Ownership: </label>
                  <select className="form-select form-select" name="ownership" onChange={(e) => setUpdateOwnership(e.target.value)}>
                    <option value="NONE" selected>Select Ownership</option>
                    <option value="LEASED" selected={updateOwnership == "LEASED" ? true : false}>LEASED</option>
                    <option value="LEADE_PURCHASED" selected={updateOwnership == "LEADE_PURCHASED" ? true : false}>LEADE PURCHASED</option>
                    <option value="OWNED" selected={updateOwnership == "OWNED" ? true : false}>OWNED</option>
                    <option value="ONE_WAY_BOX" selected={updateOwnership == "ONE_WAY_BOX" ? true : false}>ONE WAY BOX</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="owner">Owner: <i className="text-danger">*</i><span className="text-danger">{showUpdateOwnerError ? " Owner required" : ""}</span></label>
                  <select className="form-select form-select" name="owner" onBlur={(e) => e.target.value == "" ? setShowUpdateOwnerError(true) : setShowUpdateOwnerError(false)}
                    onChange={(e) => setOwner(e.target.value)}>
                    <option value="" selected>Select Owner</option>
                    {ownerList.map(owner =>
                      <option value={owner.id} selected={updateOwner == owner.id ? true : false}>{owner.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="grade">Grade: </label>
                  <select className="form-select form-select" name="grade" onChange={(e) => setUpdateGrade(e.target.value)}>
                    <option value="NONE" selected>Select Grade</option>
                    <option value="A" selected={updateGrade == "A" ? true : false}>A</option>
                    <option value="B" selected={updateGrade == "B" ? true : false}>B</option>
                    <option value="C" selected={updateGrade == "C" ? true : false}>C</option>
                    <option value="D" selected={updateGrade == "D" ? true : false}>D</option>
                    <option value="UNAVAILABLE" selected={updateGrade == "UNAVAILABLE" ? true : false}>UNAVAILABLE</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="status_date">Status Date: </label>
                  <input type="date" class="form-control form-control" id="status_date" name="status_date"
                    onChange={(e) => setUpdateStatusDate(e.target.value)} value={updateStatusDate} />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="booking_number">Booking Number: </label>
                  <input type="text" class="form-control form-control" id="booking_number" name="booking_number" placeholder="Enter Booking Number"
                    onChange={(e) => setUpdateBookingNumber(e.target.value)} value={updateBookingNumber} disabled />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="current_location">Current Location: <i className="text-danger">*</i><span className="text-danger">{showUpdateCurrentLocationError ? "Location required" : ""}</span></label>
                  <select className="form-select form-select" name="current_location" onBlur={(e) => e.target.value == "" ? setShowUpdateCurrentLocationError(true) : setShowUpdateCurrentLocationError(false)}
                    onChange={(e) => setUpdateCurrentLocation(e.target.value)}>
                    <option value="" selected>Select Location</option>
                    {portList.map(port =>
                      <option value={port.id} selected={updateCurrentLocation == port.id ? true : false}>{port.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="current_depot">Current Depot: <i className="text-danger">*</i><span className="text-danger">{showUpdateCurrentDepotError ? "Depot required" : ""}</span></label>
                  <select className="form-select form-select" name="current_depot" onBlur={(e) => e.target.value == "" ? setShowUpdateCurrentDepotError(true) : setShowUpdateCurrentDepotError(false)}
                    onChange={(e) => setUpdateCurrentDepot(e.target.value)}>
                    <option value="" selected>Select Depot</option>
                    {depotList.map(depot =>
                      <option value={depot.id} selected={updateCurrentDepot == depot.id ? true : false}>{depot.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="current_agent">Current Agent: <i className="text-danger">*</i><span className="text-danger">{showUpdateCurrentAgentError ? "Agent required" : ""}</span></label>
                  <select className="form-select form-select" name="current_agent" onBlur={(e) => e.target.value == "" ? setShowUpdateCurrentAgentError(true) : setShowUpdateCurrentAgentError(false)}
                    onChange={(e) => setUpdateCurrentAgent(e.target.value)}>
                    <option value="" selected>Select Agent</option>
                    {agentList.map(agent =>
                      <option value={agent.id} selected={updateCurrentAgent == agent.id ? true : false}>{agent.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="purchased_from">Purchased From: <i className="text-danger">*</i><span className="text-danger">{showUpdatePurchasedFromError ? "Customer required" : ""}</span></label>
                  <select className="form-select form-select" name="purchased_from" onBlur={(e) => e.target.value == "" ? setShowUpdatePurchasedFromError(true) : setShowUpdatePurchasedFromError(false)}
                    onChange={(e) => setUpdatePurchasedFrom(e.target.value)}>
                    <option value="" selected>Select Customer</option>
                    {customerList.map(customer =>
                      <option value={customer.id} selected={updatePurchasedFrom == customer.id ? true : false}>{customer.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="purchase_price">Purchase Price: <i className="text-danger">*</i><span className="text-danger">{showUpdatePurchasedPriceError ? "Price required" : ""}</span></label>
                  <input type="number" class="form-control form-control" id="purchase_price" name="purchase_price" placeholder="Enter Price"
                    onBlur={(e) => e.target.value == "" ? setShowUpdatePurchasedPriceError(true) : setShowUpdatePurchasedPriceError(false)}
                    onChange={(e) => setUpdatePurchasedPrice(e.target.value)} value={updatePurchasedPrice} />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="purchase_date">Purchase Date: <i className="text-danger">*</i><span className="text-danger">{showUpdatePurchasedDateError ? "Date required" : ""}</span></label>
                  <input type="date" class="form-control form-control" id="purchase_date" name="purchase_date"
                    onBlur={(e) => e.target.value == "" ? setShowUpdatePurchasedDateError(true) : setShowUpdatePurchasedDateError(false)}
                    onChange={(e) => setUpdatePurchasedDate(e.target.value)} value={updatePurchasedDate} />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="purchase_agent">Purchase Agent: <i className="text-danger">*</i><span className="text-danger">{showUpdatePurchaseAgentError ? "Agent required" : ""}</span></label>
                  <select className="form-select form-select" name="purchase_agent" onBlur={(e) => e.target.value == "" ? setShowUpdatePurchaseAgentError(true) : setShowUpdatePurchaseAgentError(false)}
                    onChange={(e) => setUpdatePurchaseAgent(e.target.value)}>
                    <option value="" selected>Select Agent</option>
                    {agentList.map(agent =>
                      <option value={agent.id} selected={updatePurchaseAgent == agent.id ? true : false}>{agent.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="purchase_at">Purchased At: <i className="text-danger">*</i><span className="text-danger">{showUpdatePurchasedAtError ? "Location required" : ""}</span></label>
                  <select className="form-select form-select" name="purchase_at" onBlur={(e) => e.target.value == "" ? setShowUpdatePurchasedAtError(true) : setShowUpdatePurchasedAtError(false)}
                    onChange={(e) => setUpdatePurchasedAt(e.target.value)}>
                    <option value="" selected>Select Location</option>
                    {portList.map(port =>
                      <option value={port.id} selected={updatePurchasedAt == port.id ? true : false}>{port.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="declaration_type">Declaration Type: </label>
                  <select className="form-select form-select" name="declaration_type" onChange={(e) => setUpdateDeclarationType(e.target.value)}
                    disabled={updateStatus.includes("EMPTY") ? false : true}>
                    <option value="NONE" selected={updateDeclarationType == "NONE" ? true : false}>Select Declaration Type</option>
                    <option value="ABUNDANT" selected={updateDeclarationType == "ABUNDANT" ? true : false}>ABUNDANT</option>
                    <option value="SALE_UNIT" selected={updateDeclarationType == "SALE_UNIT" ? true : false}>SALE UNIT</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="abundan_type">Abundant Type: </label>
                  <select className="form-select form-select" name="abundan_type" onChange={(e) => setUpdateAbundantType(e.target.value)}
                    disabled={updateStatus.includes("EMPTY") ? false : true}>
                    <option value="NONE" selected>Select Abundant Type</option>
                    <option value="CUSTOM_HOLD" selected={updateAbundantType == "CUSTOM_HOLD" ? true : false}>CUSTOM HOLD</option>
                    <option value="SALE_UNIT" selected={updateAbundantType == "SALE_UNIT" ? true : false}>SALE UNIT</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="sold_to">Sold To: </label>
                  <select className="form-select form-select" name="sold_to"
                    onChange={(e) => setUpdateSoldTo(e.target.value)}>
                    <option value="" selected>Select Customer</option>
                    {customerList.map(customer =>
                      <option value={customer.id} selected={updateSoldTo == customer.id ? true : false}>{customer.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="sale_price">Sale Price: </label>
                  <input type="number" class="form-control form-control" id="sale_price" name="sale_price" placeholder="Enter Price"
                    onChange={(e) => setUpdateSalePrice(e.target.value)} value={updateSalePrice} />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="sold_at">Sold At: </label>
                  <select className="form-select form-select" name="sold_at"
                    onChange={(e) => setUpdateSoldAt(e.target.value)}>
                    <option value="" selected>Select Location</option>
                    {portList.map(port =>
                      <option value={port.id} selected={updateSoldAt == port.id ? true : false}>{port.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="sale_date">Sale Date: </label>
                  <input type="date" class="form-control form-control" id="sale_date" name="sale_date"
                    onChange={(e) => setUpdateSaleDate(e.target.value)} value={updateSaleDate} />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="csc_approval_number">CSC Approval Number: </label>
                  <input type="text" class="form-control form-control" id="csc_approval_number" name="csc_approval_number" placeholder="Enter Number"
                    onChange={(e) => setUpdateCSCApprovalNumber(e.target.value)} value={updateCSCApprovalNumber} />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="gross_weight">Gross Weight: </label>
                  <input type="number" class="form-control form-control" id="gross_weight" name="gross_weight" placeholder="Enter Weight"
                    onChange={(e) => setUpdateGrossWeight(e.target.value)} value={updateGrossWeight} />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="tare_weight">Tare Weight: </label>
                  <input type="number" class="form-control form-control" id="tare_weight" name="tare_weight" placeholder="Enter Weight"
                    onChange={(e) => setUpdateTareWeight(e.target.value)} value={updateTareWeight} />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="panel_thickness">Panel Thickness (mm): </label>
                  <input type="number" class="form-control form-control" id="panel_thickness" name="panel_thickness" placeholder="Enter Panel Thickness"
                    onChange={(e) => setUpdatePanelThickness(e.target.value)} value={updatePanelThickness} />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="payload_off_weight">Payload Off Weight: </label>
                  <input type="number" class="form-control form-control" id="payload_off_weight" name="payload_off_weight" placeholder="Enter Weight"
                    onChange={(e) => setUpdatePayloadOffWeight(e.target.value)} value={updatePayloadOffWeight} />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="manufactured_on">Manufactured On: </label>
                  <input type="date" class="form-control form-control" id="manufactured_on" name="manufactured_on"
                    onChange={(e) => setUpdateManufacturedOn(e.target.value)} value={updateManufacturedOn} />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="notes">Notes: </label>
                  <input type="text" class="form-control form-control" id="notes" name="notes" placeholder="Enter Notes"
                    onChange={(e) => setUpdateNotes(e.target.value)} value={updateNotes} />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-12" : "col-md-12"}`}>
                  <Button className="btn btn-inox-green border-0 canvas-button" onClick={(e) => updateContainerDetails(e)}>
                    {showUpdateLoader ?
                      <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                      :
                      <>
                        <i className="fa fa-edit"></i> <span className="mx-2">Update</span>
                      </>
                    }

                  </Button>
                </div>
              </div>
            </form>
          </div>

          <div style={{ display: showContainerUploads ? 'block' : 'none' }}>
            <form ref={addUploadsform} onSubmit={(e) => addContainerUploads(e)}>
              <div className="row">
                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <input type="file" class="form-control form-control-sm" id="uploads" name="uploads" accept="image/*, .pdf" onChange={(e) => [handleUploadsFileChange(e.target.files), setUploadFiles(e.target.files)]} multiple />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-10" : "col-md-10"} text-left mb-4`}>
                  <Button className="btn-inox-green border-0 btn-sm" onClick={(e) => addContainerUploads(e)} disabled={uploadFiles?.length < 1 ? true : false}>
                    {showUploadFilesLoader ?
                      <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                      :
                      <span className="px-1">Upload</span>
                    }
                  </Button>
                </div>
              </div>

              {uploadFiles?.length > 0 ?
                <div className="row">
                  <div className="col-12" style={{ fontSize: 12, textAlign: 'left' }}>
                    Files: {uploadFileNames.map((name, index) => (
                      <span key={index}>
                        {!index == 0 ? ",   " : ""}
                        <b>{index + 1}:</b> {name}
                      </span>
                    ))}
                  </div>
                </div>
                : ""}
            </form>


            {containerUploads?.length > 0 ?
              <DataTable
                columns={uploadcolumns}
                data={containerUploads}
                progressPending={containerUploadDataPending}
                progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                noDataComponent={<p className="text-center table-no-data">No Uploads Found</p>}
                pagination
                highlightOnHover
                fixedHeader
                customStyles={userTableCustomStyles}
                dense
              />
              :
              <p style={{ marginTop: 100 }}>No Uploads Found</p>
            }

            <Modal size="sm" show={deleteContainerUploadModal} onHide={() => setDeleteContainerUploadModal(false)} centered>
              <Modal.Header closeButton>
                <Modal.Title>Delete <span style={{ fontSize: 10 }}>({deleteUploadFileName})</span></Modal.Title>
              </Modal.Header>
              <Modal.Body>Do you want to delete this file?</Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setDeleteContainerUploadModal(false)}>Close</Button>
                <Button variant="danger" onClick={(e) => deleteContainerUploads(e)}>
                  {showDeleteUploadFilesLoader ?
                    <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    :
                    "Delete"
                  }

                </Button>
              </Modal.Footer>
            </Modal>
          </div>

          <div style={{ display: showContainerHistory ? 'block' : 'none' }}>
            {containerHistoryData?.length > 0 ?
              <DataTable
                columns={historycolumns}
                data={containerHistoryData}
                progressPending={containerHistoryDataPending}
                progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                noDataComponent={<p className="text-center table-no-data">No History Found</p>}
                pagination
                highlightOnHover
                fixedHeader
                customStyles={userTableCustomStyles}
                dense
              />
              :
              <p style={{ marginTop: 100 }}>No History Found</p>
            }
          </div>

          <div style={{ display: showContainerSaleApprove ? 'block' : 'none' }}>
            <Accordion defaultActiveKey="0">

              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  Sale Unit Approval
                </Accordion.Header>

                <Accordion.Body>
                  <div className="row">
                    <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                      <label for="container_number">Container Number: <i className="text-danger">*</i><span className="text-danger">{showUpdateContainerNumberError ? "Container Number required" : ""}</span></label>
                      <input type="text" class="form-control form-control" id="container_number" name="container_number" placeholder="Enter Container Number"
                        value={updateContainerNumber} disabled />
                    </div>
                  </div>
                  <div className="row">
                    <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                      <label for="sale_price">Sale Price ($): </label>
                      <input type="number" class="form-control form-control" id="sale_price" name="sale_price" placeholder="Enter Price" value={updateSalePrice || ""} onChange={(e) => setUpdateSalePrice(e.target.value)}   />
                    </div>
                    <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                      <label for="sale_price_by">Sale Price By: </label>
                      <select className="form-select form-select" name="sale_price_by" value={updateSalePriceBy || ""} onChange={(e) => setUpdateSalePriceBy(e.target.value)}>
                        <option value="">Select</option>
                        {userList.map(user =>
                          <option key={user.id} value={user.id}>{user.name}</option>
                        )}
                      </select>
                    </div>
                    <div className="row">
                    <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                      <label for="approval_approved_sale_price">Approved Sale Price: </label>
                      <input type="number" class="form-control form-control" id="approval_approved_sale_price" name="approved_sale_price" placeholder="Enter Price"
                        value={updateApprovedSalePrice || ""} onChange={(e) => setUpdateApprovedSalePrice(e.target.value)} />
                    </div>
                    <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                      <label for="approval_approved_sale_price_date">Approved Sale Price Date: </label>
                      <input type="date" class="form-control form-control" id="approval_approved_sale_price_date" name="approved_sale_price_date"
                        value={updateApprovedSalePriceDate || ""} onChange={(e) => setUpdateApprovedSalePriceDate(e.target.value)} />
                    </div>
                    <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                      <label for="approval_approved_sale_price_by">Approved Sale Price By: </label>
                      <select className="form-select form-select" id="approval_approved_sale_price_by" name="approved_sale_price_by" value={updateApprovedSalePriceBy || ""} onChange={(e) => setUpdateApprovedSalePriceBy(e.target.value)}>
                        <option value="">Select</option>
                        {userList.map(user =>
                          <option key={user.id} value={user.id}>{user.name}</option>
                        )}
                      </select>
                    </div>
                    </div>
                    <div className="row">
                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="sold_to">Sold To: </label>
                          <select className="form-select form-select" name="sold_to"
                            onChange={(e) => setUpdateSoldTo(e.target.value)}>
                            <option value="" selected>Select Customer</option>
                            {customerList.map(customer =>
                              <option value={customer.id} selected={updateSoldTo == customer.id ? true : false}>{customer.name}</option>
                            )}
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="sold_at">Sold At: </label>
                          <select className="form-select form-select" name="sold_at"
                            onChange={(e) => setUpdateSoldAt(e.target.value)}>
                            <option value="" selected>Select Location</option>
                            {portList.map(port =>
                              <option value={port.id} selected={updateSoldAt == port.id ? true : false}>{port.name}</option>
                            )}
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="sale_date">Sale Date: </label>
                          <input type="date" class="form-control form-control" id="sale_date" name="sale_date"
                            onChange={(e) => setUpdateSaleDate(e.target.value)} value={updateSaleDate} />
                        </div>
                    </div>
                  </div>  
                    {/* <Button className="btn sm btn-inox-green border-0 canvas-button" onClick={(e) => updateContainerDetails(e)}>Save Sale Price</Button> */}
                    <Button className="btn btn-sm btn-inox-green border-0" title="Save Sale Price" data-bs-toggle="offcanvas" data-bs-target="#updateSection" onClick={(e) => updateContainerDetails(e)}>
                      <i className="fa fa-save"></i> <span className="mx-2">Update Sale Approve</span>
                    </Button>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  Purchase Detail Record
                </Accordion.Header>

                <Accordion.Body>
                  <div className="row">
                    <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                      <label for="container_number">Container Number: <i className="text-danger">*</i><span className="text-danger">{showUpdateContainerNumberError ? "Container Number required" : ""}</span></label>
                      <input type="text" class="form-control form-control" id="container_number" name="container_number" placeholder="Enter Container Number"
                        value={updateContainerNumber} disabled />
                    </div>
                    <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                      <label for="current_location">Current Location: </label>
                      <select className="form-select form-select" disabled name="current_location">
                        <option value="" selected>Select Location</option>
                        {portList.map(port =>
                          <option value={port.id} selected={updateCurrentLocation == port.id ? true : false}>{port.name}</option>
                        )}
                      </select>
                    </div>
                    <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                      <label for="purchased_from">Purchased From: </label>
                      <select className="form-select form-select" disabled name="purchased_from"
                      >
                        <option value="" selected>Select Customer</option>
                        {customerList.map(customer =>
                          <option value={customer.id} selected={updatePurchasedFrom == customer.id ? true : false}>{customer.name}</option>
                        )}
                      </select>
                    </div>

                    <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                      <label for="purchase_price">Purchase Price: </label>
                      <input type="number" class="form-control form-control" id="purchase_price" disabled name="purchase_price" placeholder="Enter Price" value={updatePurchasedPrice} />
                    </div>

                    <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                      <label for="purchase_date">Purchase Date: </label>
                      <input type="date" class="form-control form-control" id="purchase_date" disabled name="purchase_date" value={updatePurchasedDate} />
                    </div>

                    <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                      <label for="purchase_at">Purchased At: </label>
                      <select className="form-select form-select" disabled name="purchase_at">
                        <option value="" selected>Select Location</option>
                        {portList.map(port =>
                          <option value={port.id} selected={updatePurchasedAt == port.id ? true : false}>{port.name}</option>
                        )}
                      </select>
                    </div>

                    <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                      <label for="status">Status: </label>
                      <select className="form-select form-select" disabled name="status" onChange={(e) => setUpdateStatus(e.target.value)}>
                        <option value="EMPTY_AV" selected>Select Status</option>
                        <option value="BOOKED" selected={updateStatus == "BOOKED" ? true : false}>BOOKED</option>
                        <option value="EMPTY_AV" selected={updateStatus == "EMPTY_AV" ? true : false}>EMPTY AV</option>
                        <option value="EMPTY_APPROVED" selected={updateStatus == "EMPTY_APPROVED" ? true : false}>EMPTY APPROVED</option>
                        <option value="EMPTY_ESTIMATED" selected={updateStatus == "EMPTY_ESTIMATED" ? true : false}>EMPTY ESTIMATED</option>
                        <option value="EMPTY_REPAIRED" selected={updateStatus == "EMPTY_REPAIRED" ? true : false}>EMPTY REPAIRED</option>
                        <option value="EMPTY_UNESTIMATED" selected={updateStatus == "EMPTY_UNESTIMATED" ? true : false}>EMPTY UNESTIMATED</option>
                        <option value="EXPORTED" selected={updateStatus == "EXPORTED" ? true : false}>EXPORTED</option>
                        <option value="IMPORT_LADEN" selected={updateStatus == "IMPORT_LADEN" ? true : false}>IMPORT LADEN</option>
                        <option value="LEASED_OUT" selected={updateStatus == "LEASED_OUT" ? true : false}>LEASED OUT</option>
                        <option value="OFFHIRED" selected={updateStatus == "OFFHIRED" ? true : false}>OFFHIRED</option>
                        <option value="ON_THE_WAY" selected={updateStatus == "ON_THE_WAY" ? true : false}>ON THE WAY</option>
                        <option value="PICKED" selected={updateStatus == "PICKED" ? true : false}>PICKED</option>
                        <option value="SOLD_UNIT" selected={updateStatus == "SOLD_UNIT" ? true : false}>SOLD UNIT</option>
                      </select>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>


            </Accordion>
          </div>
        </div>
      </div>
      {/* ------------------------ Update Section ------------------- */}

      {/* ------------------------ Add Section ------------------- */}
      <div class={canvasFullScreen && showAddCanvas ? "offcanvas offcanvas-bottom h-100 show" :
        !canvasFullScreen && showAddCanvas ? "offcanvas offcanvas-bottom h-60 show" : "offcanvas offcanvas-bottom h-60"}
        data-bs-scroll="true" tabindex="-1" id="addSection" aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Add New Record</h4>
            </div>
            <div className="col-6">
              <button type="button" class="btn btn-danger btn-sm float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close"
                onClick={() => [
                  setShowAddCanvas(false),
                  resetAddForm()
                ]}>
                <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen ?
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Half Screen" onClick={() => [setCanvasFullScreen(false), setShowAddCanvas(true)]}>
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
                :
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Full Screen" onClick={() => [setCanvasFullScreen(true), setShowAddCanvas(true)]}>
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              }
            </div>
          </div>
        </div>

        <div class="offcanvas-body" style={{ paddingLeft: 20, paddingRight: 40 }}>
          <div className="row">
            <div className="col-12">
              <Stepper activeStep={activeStep} styleConfig={{ activeBgColor: '#12708C', completedBgColor: '#16576b' }}>
                {steps.map((label, index) => (
                  <Step label={label} key={index} onClick={() => setActiveStep(index)} />
                ))}
              </Stepper>
            </div>

            <div className="col-12 mt-3">
              <form ref={addform}>
                <div className="step-content">
                  {
                    activeStep === 0 &&
                    <div>
                      <div className="row">
                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="container_number">Container Number: <i className="text-danger">*</i><span className="text-danger">{showContainerNumberError ? " Valid Format is 3 Characters A-Z + U + 7 digits" : ""}</span></label>
                          <Select
                            id="container_number"
                            options={containerNumberList}
                            components={customComponents}
                            inputValue={containerNumber}
                            onInputChange={(value, { action }) => {
                              if (action !== 'input-blur' && action !== 'menu-close') {
                                setContainerNumber(value.toUpperCase());
                                setContainerNumberExist(containerNumberList.some(number => number.value.toUpperCase().includes(value.toUpperCase())));
                                setInputAction(true)
                              }
                            }}
                            isClearable={false}
                            onBlur={(e) => {
                              setContainerNumberExist(false);
                              if (inputAction) {
                                setContainerNumber(e.target.value.toUpperCase());
                                checkContainerNumberExist(e.target.value.toUpperCase())
                                checkContainerNumberFormat(e.target.value.toUpperCase())
                              }
                              else {
                                checkContainerNumberExist(containerNumberSelected.value)
                              }
                            }}
                            menuIsOpen={containerNumber?.length > 3 && containerNumberExist ? true : false}
                            noOptionsMessage={() => 'No container with this number'}
                            onChange={(e) => {
                              setContainerNumberSelected(e);
                              setContainerNumberExist(containerNumberList.some(number => number.value.toUpperCase().includes(e.value.toUpperCase())));
                              setInputAction(false)
                            }}
                            value={containerNumberSelected}
                          />
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="type">Container Type: <i className="text-danger">*</i><span className="text-danger">{showTypeError ? "Container Type required" : ""}</span></label>
                          <select className="form-select form-select" name="type" onBlur={(e) => e.target.value == "" ? setShowTypeError(true) : setShowTypeError(false)}
                            onChange={(e) => setType(e.target.value)}>
                            <option value="" selected>Select Container Type</option>
                            <option value="GP20" selected={updateType == "GP20" ? true : false}>20 GP</option>
                            <option value="GP40" selected={updateType == "GP40" ? true : false}>20 GP</option>
                            <option value="HD20" selected={type == "HD20" ? true : false}>20 HD</option>
                            <option value="HD40" selected={type == "HD40" ? true : false}>40 HD</option>
                            <option value="HQ40" selected={type == "HQ40" ? true : false}>40 HQ</option>
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="principal">Principal: <i className="text-danger">*</i><span className="text-danger">{showPrincipalError ? " Principal required" : ""}</span></label>
                          <select className="form-select form-select" name="principal" onBlur={(e) => e.target.value == "" ? setShowPrincipalError(true) : setShowPrincipalError(false)}
                            onChange={(e) => setPrincipal(e.target.value)}>
                            <option value="" selected>Select Principal</option>
                            {principalList.map(currentprincipal =>
                              <option value={currentprincipal.id} selected={principal == currentprincipal.id ? true : false}>{currentprincipal.name}</option>
                            )}
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="status">Status: </label>
                          <select className="form-select form-select" name="status" onChange={(e) => setStatus(e.target.value)}>
                            <option value="EMPTY_AV" selected>Select Status</option>
                            <option value="BOOKED" selected={status == "BOOKED" ? true : false}>BOOKED</option>
                            <option value="EMPTY_AV" selected={status == "EMPTY_AV" ? true : false}>EMPTY AV</option>
                            <option value="EMPTY_APPROVED" selected={status == "EMPTY_APPROVED" ? true : false}>EMPTY APPROVED</option>
                            <option value="EMPTY_ESTIMATED" selected={status == "EMPTY_ESTIMATED" ? true : false}>EMPTY ESTIMATED</option>
                            <option value="EMPTY_REPAIRED" selected={status == "EMPTY_REPAIRED" ? true : false}>EMPTY REPAIRED</option>
                            <option value="EMPTY_UNESTIMATED" selected={status == "EMPTY_UNESTIMATED" ? true : false}>EMPTY UNESTIMATED</option>
                            <option value="EXPORTED" selected={status == "EXPORTED" ? true : false}>EXPORTED</option>
                            <option value="IMPORT_LADEN" selected={status == "IMPORT_LADEN" ? true : false}>IMPORT LADEN</option>
                            <option value="LEASED_OUT" selected={status == "LEASED_OUT" ? true : false}>LEASED OUT</option>
                            <option value="OFFHIRED" selected={status == "OFFHIRED" ? true : false}>OFFHIRED</option>
                            <option value="ON_THE_WAY" selected={status == "ON_THE_WAY" ? true : false}>ON THE WAY</option>
                            <option value="PICKED" selected={status == "PICKED" ? true : false}>PICKED</option>
                            <option value="SOLD_UNIT" selected={status == "SOLD_UNIT" ? true : false}>SOLD UNIT</option>
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="ownership">Ownership: <i className="text-danger">*</i><span className="text-danger">{showOwnershipError ? " Ownership required" : ""}</span></label>
                          <select className="form-select form-select" name="ownership" onBlur={(e) => e.target.value == "" ? setShowOwnershipError(true) : setShowOwnershipError(false)}
                            onChange={(e) => setOwnership(e.target.value)}>
                            <option value="NONE" selected>Select Ownership</option>
                            <option value="LEASED" selected={ownership == "LEASED" ? true : false}>LEASED</option>
                            <option value="LEADE_PURCHASED" selected={ownership == "LEADE_PURCHASED" ? true : false}>LEADE PURCHASED</option>
                            <option value="OWNED" selected={ownership == "OWNED" ? true : false}>OWNED</option>
                            <option value="ONE_WAY_BOX" selected={ownership == "ONE_WAY_BOX" ? true : false}>ONE WAY BOX</option>
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="owner">Owner: <i className="text-danger">*</i><span className="text-danger">{showOwnerError ? " Owner required" : ""}</span></label>
                          <select className="form-select form-select" name="owner" onBlur={(e) => e.target.value == "" ? setShowOwnerError(true) : setShowOwnerError(false)}
                            onChange={(e) => setOwner(e.target.value)}>
                            <option value="" selected>Select Owner</option>
                            {ownerList.map(currentowner =>
                              <option value={currentowner.id} selected={owner == currentowner.id ? true : false}>{currentowner.name}</option>
                            )}
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="grade">Grade: </label>
                          <select className="form-select form-select" name="grade" onChange={(e) => setGrade(e.target.value)}>
                            <option value="NONE" selected>Select Grade</option>
                            <option value="A" selected={grade == "A" ? true : false}>A</option>
                            <option value="B" selected={grade == "B" ? true : false}>B</option>
                            <option value="C" selected={grade == "C" ? true : false}>C</option>
                            <option value="D" selected={grade == "D" ? true : false}>D</option>
                            <option value="UNAVAILABLE" selected={grade == "UNAVAILABLE" ? true : false}>UNAVAILABLE</option>
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="status_date">Status Date: </label>
                          <input type="date" class="form-control form-control" id="status_date" name="status_date"
                            onChange={(e) => setStatusDate(e.target.value)} value={statusDate} />
                        </div>

                        {/* <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="booking_number">Booking Number: <i className="text-danger">*</i><span className="text-danger">{showBookingNumberError ? "Booking Number required" : ""}</span></label>
                          <input type="text" class="form-control form-control" id="booking_number" name="booking_number" placeholder="Enter Booking Number"
                            onBlur={(e) => e.target.value == "" ? setShowBookingNumberError(true) : setShowBookingNumberError(false)}
                            onChange={(e) => setBookingNumber(e.target.value)} value={bookingNumber} />
                        </div> */}

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="current_location">Current Location: <i className="text-danger">*</i><span className="text-danger">{showCurrentLocationError ? "Location required" : ""}</span></label>
                          <select className="form-select form-select" name="current_location" onBlur={(e) => e.target.value == "" ? setShowCurrentLocationError(true) : setShowCurrentLocationError(false)}
                            onChange={(e) => setCurrentLocation(e.target.value)}>
                            <option value="" selected>Select Location</option>
                            {portList.map(port =>
                              <option value={port.id} selected={currentLocation == port.id ? true : false}>{port.name}</option>
                            )}
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="current_depot">Current Depot: <i className="text-danger">*</i><span className="text-danger">{showCurrentDepotError ? "Depot required" : ""}</span></label>
                          <select className="form-select form-select" name="current_depot" onBlur={(e) => e.target.value == "" ? setShowCurrentDepotError(true) : setShowCurrentDepotError(false)}
                            onChange={(e) => setCurrentDepot(e.target.value)}>
                            <option value="" selected>Select Depot</option>
                            {depotList.map(depot =>
                              <option value={depot.id} selected={currentDepot == depot.id ? true : false}>{depot.name}</option>
                            )}
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="current_agent">Current Agent: <i className="text-danger">*</i><span className="text-danger">{showCurrentAgentError ? "Agent required" : ""}</span></label>
                          <select className="form-select form-select" name="current_agent" onBlur={(e) => e.target.value == "" ? setShowCurrentAgentError(true) : setShowCurrentAgentError(false)}
                            onChange={(e) => setCurrentAgent(e.target.value)}>
                            <option value="" selected>Select Agent</option>
                            {agentList.map(agent =>
                              <option value={agent.id} selected={currentAgent == agent.id ? true : false}>{agent.name}</option>
                            )}
                          </select>
                        </div>
                      </div>
                    </div>
                  }

                  {activeStep === 1 &&
                    <div>
                      <div className="row">
                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="purchased_from">Purchased From: <i className="text-danger">*</i><span className="text-danger">{showPurchasedFromError ? "Customer required" : ""}</span></label>
                          <select className="form-select form-select" name="purchased_from" onBlur={(e) => e.target.value == "" ? setShowPurchasedFromError(true) : setShowPurchasedFromError(false)}
                            onChange={(e) => setPurchasedFrom(e.target.value)}>
                            <option value="" selected>Select Customer</option>
                            {customerList.map(customer =>
                              <option value={customer.id} selected={purchasedFrom == customer.id ? true : false}>{customer.name}</option>
                            )}
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="purchase_price">Purchase Price: <i className="text-danger">*</i><span className="text-danger">{showPurchasedPriceError ? "Price required" : ""}</span></label>
                          <input type="number" class="form-control form-control" id="purchase_price" name="purchase_price" placeholder="Enter Price"
                            onBlur={(e) => e.target.value == "" ? setShowPurchasedPriceError(true) : setShowPurchasedPriceError(false)}
                            onChange={(e) => setPurchasedPrice(e.target.value)} value={purchasedPrice} />
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="purchase_date">Purchase Date: <i className="text-danger">*</i><span className="text-danger">{showPurchasedDateError ? "Date required" : ""}</span></label>
                          <input type="date" class="form-control form-control" id="purchase_date" name="purchase_date"
                            onBlur={(e) => e.target.value == "" ? setShowPurchasedDateError(true) : setShowPurchasedDateError(false)}
                            onChange={(e) => setPurchasedDate(e.target.value)} value={purchasedDate} />
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="purchase_agent">Purchase Agent: <i className="text-danger">*</i><span className="text-danger">{showPurchaseAgentError ? "Agent required" : ""}</span></label>
                          <select className="form-select form-select" name="purchase_agent" onBlur={(e) => e.target.value == "" ? setShowPurchaseAgentError(true) : setShowPurchaseAgentError(false)}
                            onChange={(e) => setPurchaseAgent(e.target.value)}>
                            <option value="" selected>Select Agent</option>
                            {agentList.map(agent =>
                              <option value={agent.id} selected={purchaseAgent == agent.id ? true : false}>{agent.name}</option>
                            )}
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="purchase_at">Purchased At: <i className="text-danger">*</i><span className="text-danger">{showPurchasedAtError ? "Location required" : ""}</span></label>
                          <select className="form-select form-select" name="purchase_at" onBlur={(e) => e.target.value == "" ? setShowPurchasedAtError(true) : setShowPurchasedAtError(false)}
                            onChange={(e) => setPurchasedAt(e.target.value)}>
                            <option value="" selected>Select Location</option>
                            {portList.map(port =>
                              <option value={port.id} selected={purchasedAt == port.id ? true : false}>{port.name}</option>
                            )}
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="declaration_type">Declaration Type: </label>
                          <select className="form-select form-select" name="declaration_type" onChange={(e) => setDeclarationType(e.target.value)}
                            disabled={status?.includes("EMPTY") ? false : true}>
                            <option value="NONE" selected>Select Declaration Type</option>
                            <option value="ABUNDANT" selected={declarationType == "ABUNDANT" ? true : false}>ABUNDANT</option>
                            <option value="SALE_UNIT" selected={declarationType == "SALE_UNIT" ? true : false}>SALE UNIT</option>
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="abundan_type">Abundant Type: </label>
                          <select className="form-select form-select" name="abundan_type" onChange={(e) => setAbundantType(e.target.value)}
                            disabled={status?.includes("EMPTY") ? false : true}>
                            <option value="NONE" selected>Select Abundant Type</option>
                            <option value="CUSTOM_HOLD" selected={abundantType == "CUSTOM_HOLD" ? true : false}>CUSTOM HOLD</option>
                            <option value="SALE_UNIT" selected={abundantType == "SALE_UNIT" ? true : false}>SALE UNIT</option>
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="sold_to">Sold To: </label>
                          <select className="form-select form-select" name="sold_to" onChange={(e) => setSoldTo(e.target.value)}>
                            <option value="" selected>Select Customer</option>
                            {customerList.map(customer =>
                              <option value={customer.id} selected={soldTo == customer.id ? true : false}>{customer.name}</option>
                            )}
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="sale_price">Sale Price: </label>
                          <input type="number" class="form-control form-control" id="sale_price" name="sale_price" placeholder="Enter Price"
                            onChange={(e) => setSalePrice(e.target.value)} value={salePrice} />
                        </div>

                        {/* <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="sale_price_by">Sale Price By: </label>
                          <select className="form-select form-select" id="sale_price_by" name="sale_price_by" onChange={(e) => setSalePriceBy(e.target.value)}>
                            <option value="">Select User</option>
                            {userList.map(user =>
                              <option key={user.id} value={user.id}>{user.name}</option>
                            )}
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="approved_sale_price">Approved Sale Price: </label>
                          <input type="number" class="form-control form-control" id="approved_sale_price" name="approved_sale_price" placeholder="Enter Price"
                            onChange={(e) => setApprovedSalePrice(e.target.value)} value={approvedSalePrice} />
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="approved_sale_price_date">Approved Sale Price Date: </label>
                          <input type="date" class="form-control form-control" id="approved_sale_price_date" name="approved_sale_price_date"
                            onChange={(e) => setApprovedSalePriceDate(e.target.value)} value={approvedSalePriceDate || ""} />
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="approved_sale_price_by">Approved Sale Price By: </label>
                          <select className="form-select form-select" id="approved_sale_price_by" name="approved_sale_price_by" onChange={(e) => setApprovedSalePriceBy(e.target.value)}>
                            <option value="">Select User</option>
                            {userList.map(user =>
                              <option key={user.id} value={user.id}>{user.name}</option>
                            )}
                          </select>
                        </div> */}

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="sold_at">Sold At: </label>
                          <select className="form-select form-select" name="sold_at" onChange={(e) => setSoldAt(e.target.value)}>
                            <option value="" selected>Select Location</option>
                            {portList.map(port =>
                              <option value={port.id} selected={soldAt == port.id ? true : false}>{port.name}</option>
                            )}
                          </select>
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="sale_date">Sale Date: </label>
                          <input type="date" class="form-control form-control" id="sale_date" name="sale_date"
                            onChange={(e) => setSaleDate(e.target.value)} value={saleDate} />
                        </div>
                      </div>
                    </div>}

                  {activeStep === 2 &&
                    <div>
                      <div className="row">
                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="csc_approval_number">CSC Approval Number: </label>
                          <input type="text" class="form-control form-control" id="csc_approval_number" name="csc_approval_number" placeholder="Enter Number"
                            onChange={(e) => setCSCApprovalNumber(e.target.value)} value={cSCApprovalNumber} />
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="gross_weight">Gross Weight: </label>
                          <input type="number" class="form-control form-control" id="gross_weight" name="gross_weight" placeholder="Enter Weight"
                            onChange={(e) => setGrossWeight(e.target.value)} value={grossWeight} />
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="tare_weight">Tare Weight: </label>
                          <input type="number" class="form-control form-control" id="tare_weight" name="tare_weight" placeholder="Enter Weight"
                            onChange={(e) => setTareWeight(e.target.value)} value={tareWeight} />
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="panel_thickness">Panel Thickness (mm): </label>
                          <input type="number" class="form-control form-control" id="panel_thickness" name="panel_thickness" placeholder="Enter Panel Thickness"
                            onChange={(e) => setPanelThickness(e.target.value)} value={panelThickness} />
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="payload_off_weight">Payload Off Weight: </label>
                          <input type="number" class="form-control form-control" id="payload_off_weight" name="payload_off_weight" placeholder="Enter Weight"
                            onChange={(e) => setPayloadOffWeight(e.target.value)} value={payloadOffWeight} />
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="manufactured_on">Manufactured On: </label>
                          <input type="date" class="form-control form-control" id="manufactured_on" name="manufactured_on"
                            onChange={(e) => setManufacturedOn(e.target.value)} value={manufacturedOn} />
                        </div>

                        <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                          <label for="notes">Notes: </label>
                          <input type="text" class="form-control form-control" id="notes" name="notes" placeholder="Enter Notes"
                            onChange={(e) => setNotes(e.target.value)} value={notes} />
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </form>
              <div class={`form-group ${canvasFullScreen ? "col-md-12" : "col-md-12"}`}>
                <span className="btn btn-inox-green border-0" style={{ width: 200, marginRight: 10, color: '#FFF' }} onClick={() => setActiveStep((prev) => Math.max(prev - 1, 0))} disabled={activeStep === 0}>
                  Back
                </span>

                {activeStep == 2 ?
                  <>
                    <Button type="submit" className="btn btn-inox-green border-0 canvas-button" style={{ width: 100, marginTop: 20 }} onClick={(e) => addNewContainer(e)}>
                      {showAddLoader ?
                        <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        :
                        <>
                          {!formAsUpdate ?
                            <><i className="fa fa-plus"></i><span className="mx-2">Add Container</span></>
                            :
                            <><i className="fa fa-edit"></i><span className="mx-2">Update Container</span></>
                          }
                        </>
                      }
                    </Button>

                    {showValidationError ?
                      <>
                        <Button style={{ backgroundColor: "#C21E22", border: "#f82e2e" }} title="Show Errors" className="mx-2" onClick={handleCheckValidationClick}
                          onMouseLeave={() => setIsValidationErrorVisible(false)}>
                          <i className="fa fa-exclamation"></i>
                        </Button>
                        {isValidationErrorVisible &&
                          <div className="validation-error-tooltip">
                            <ul className="mb-0 px-4">
                              {validationErrorArray.map((error, index) => (
                                <li key={index} className="text-left small pb-0">{error}</li>
                              ))}
                            </ul>
                          </div>
                        }
                      </>
                      : ""
                    }
                  </>
                  :
                  <span className="btn btn-inox-green border-0" style={{ width: 200, color: '#FFF' }} onClick={() => setActiveStep((prev) => Math.min(prev + 1, steps.length - 1))} disabled={activeStep === steps.length - 1}>
                    Next
                  </span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ------------------------ Add Section ------------------- */}

      {/* ----------------------------- History Section --------------------- */}
      <Modal show={showHistoryModal} onHide={handleHistoryModalClose} centered fullscreen>
        <Modal.Header closeButton>
          <Modal.Title>History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div>
              <div className="row">
                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="container_number">Container Number: <i className="text-danger">*</i><span className="text-danger">{showHistoryContainerNumberError ? "Container Number required" : ""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="container_number" name="container_number" placeholder="Enter Container Number"
                    onBlur={(e) => e.target.value == "" ? setShowHistoryContainerNumberError(true) : setShowHistoryContainerNumberError(false)}
                    onChange={(e) => setHistoryContainerNumber(e.target.value)} value={historyContainerNumber} disabled />
                </div>

                {/* <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="update_sale_price_by">Sale Price By: </label>
                  <select className="form-select form-select" id="update_sale_price_by" name="sale_price_by" onChange={(e) => setUpdateSalePriceBy(e.target.value)}>
                    <option value="">Select User</option>
                    {userList.map(user =>
                      <option key={user.id} value={user.id} selected={updateSalePriceBy == user.id ? true : false}>{user.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="update_approved_sale_price">Approved Sale Price: </label>
                  <input type="number" class="form-control form-control" id="update_approved_sale_price" name="approved_sale_price" placeholder="Enter Price"
                    onChange={(e) => setUpdateApprovedSalePrice(e.target.value)} value={updateApprovedSalePrice} />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="update_approved_sale_price_date">Approved Sale Price Date: </label>
                  <input type="date" class="form-control form-control" id="update_approved_sale_price_date" name="approved_sale_price_date"
                    onChange={(e) => setUpdateApprovedSalePriceDate(e.target.value)} value={updateApprovedSalePriceDate || ""} />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}>
                  <label for="update_approved_sale_price_by">Approved Sale Price By: </label>
                  <select className="form-select form-select" id="update_approved_sale_price_by" name="approved_sale_price_by" onChange={(e) => setUpdateApprovedSalePriceBy(e.target.value)}>
                    <option value="">Select User</option>
                    {userList.map(user =>
                      <option key={user.id} value={user.id} selected={updateApprovedSalePriceBy == user.id ? true : false}>{user.name}</option>
                    )}
                  </select>
                </div> */}

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="booking_number">Booking Number: <i className="text-danger">*</i><span className="text-danger">{showHistoryBookingNumberError ? "Booking Number required" : ""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="booking_number" name="booking_number" placeholder="Enter Booking Number"
                    onBlur={(e) => e.target.value == "" ? setShowHistoryBookingNumberError(true) : setShowHistoryBookingNumberError(false)}
                    onChange={(e) => setHistoryBookingNumber(e.target.value)} value={historyBookingNumber} disabled />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="type">Container Type: <i className="text-danger">*</i><span className="text-danger">{showHistoryTypeError ? "Container Type required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="type" onBlur={(e) => e.target.value == "" ? setShowHistoryTypeError(true) : setShowHistoryTypeError(false)}
                    onChange={(e) => setHistoryType(e.target.value)} disabled>
                    <option value="" selected>Select Container Type</option>
                    <option value="HD20" selected={historyType == "HD20" ? true : false}>20 HD</option>
                    <option value="HD40" selected={historyType == "HD40" ? true : false}>40 HD</option>
                    <option value="HQ40" selected={historyType == "HQ40" ? true : false}>40 HQ</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="status">Estimation Status: </label>
                  <select className="form-select form-control-sm" name="status" onChange={(e) => setHistoryStatus(e.target.value)} disabled>
                    <option value="UNDER_REPAIRED" selected={historyStatus == "UNDER_REPAIRED" ? true : false}>UNDER REPAIRED</option>
                    <option value="REPAIR_COMPLETE" selected={historyStatus == "REPAIR_COMPLETE" ? true : false}>UNDER REPAIRED</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="depot_date">Depot Date In: <i className="text-danger">*</i><span className="text-danger">{showHistoryDepotDateError ? "Date required" : ""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="depot_date" name="depot_date"
                    onBlur={(e) => e.target.value == "" ? setShowHistoryDepotDateError(true) : setShowHistoryDepotDateError(false)}
                    onChange={(e) => setHistoryDepotDate(e.target.value)} value={historyDepotDate} disabled />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="cargo">Cargo: <i className="text-danger">*</i><span className="text-danger">{showHistoryCargoError ? " Cargo required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="cargo" onBlur={(e) => e.target.value == "" ? setShowHistoryCargoError(true) : setShowHistoryCargoError(false)}
                    onChange={(e) => setHistoryCargo(e.target.value)} disabled>
                    <option value="" selected>Select Cargo</option>
                    {cargoList.map(cargo =>
                      <option value={cargo.id} selected={historyCargo == cargo.id ? true : false}>{cargo.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="currency">Currency: <i className="text-danger">*</i><span className="text-danger">{showHistoryCurrencyError ? "Currency required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="currency" onBlur={(e) => e.target.value == "" ? setShowHistoryCurrencyError(true) : setShowHistoryCurrencyError(false)}
                    onChange={(e) => setHistoryCurrency(e.target.value)} disabled>
                    <option value="" selected>Select Currency</option>
                    {currencyList.map(currency =>
                      <option value={currency.id} selected={historyCurrency == currency.id ? true : false}>{currency.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="grade">Grade: </label>
                  <select className="form-select form-select-sm" name="grade" onChange={(e) => setHistoryGrade(e.target.value)} disabled>
                    <option value="NONE" selected>Select Grade</option>
                    <option value="A" selected={historyGrade == "A" ? true : false}>A</option>
                    <option value="B" selected={historyGrade == "B" ? true : false}>B</option>
                    <option value="C" selected={historyGrade == "C" ? true : false}>C</option>
                    <option value="D" selected={historyGrade == "D" ? true : false}>D</option>
                    <option value="UNAVAILABLE" selected={historyGrade == "UNAVAILABLE" ? true : false}>UNAVAILABLE</option>
                  </select>
                </div>
              </div>

              <div className="row">
                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="estimated_amount">Estimated Amount: <i className="text-danger">*</i><span className="text-danger">{showHistoryEstimatedAmountError ? "Amount required" : ""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="estimated_amount" name="estimated_amount" placeholder="Enter Amount"
                    onBlur={(e) => e.target.value == "" ? setShowHistoryEstimatedAmountError(true) : setShowHistoryEstimatedAmountError(false)}
                    onChange={(e) => setHistoryEstimatedAmount(e.target.value)} value={historyEstimatedAmount} disabled />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="estimated_by">Estimated By: <i className="text-danger">*</i><span className="text-danger">{showHistoryEstimatedByError ? "Estimated By required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="estimated_by" onBlur={(e) => e.target.value == "" ? setShowHistoryEstimatedByError(true) : setShowHistoryEstimatedByError(false)}
                    onChange={(e) => setHistoryEstimatedBy(e.target.value)} disabled>
                    <option value="" selected>Select Estimated By</option>
                    {userList.map(user =>
                      <option value={user.id} selected={historyEstimatedBy == user.id ? true : false}>{user.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="estimated_date">Estimated Date: <i className="text-danger">*</i><span className="text-danger">{showHistoryEstimatedDateError ? "Date required" : ""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="estimated_date" name="estimated_date"
                    onBlur={(e) => e.target.value == "" ? setShowHistoryEstimatedDateError(true) : setShowHistoryEstimatedDateError(false)}
                    onChange={(e) => setHistoryEstimatedDate(e.target.value)} value={historyEstimatedDate} disabled />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="estimate_notes">Estimate Notes: </label>
                  <input type="text" class="form-control form-control-sm" id="estimate_notes" name="estimate_notes"
                    onChange={(e) => setHistoryEstimateNotes(e.target.value)} value={historyEstimateNotes} />
                </div>
              </div>

              <div className="row">
                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="approved_amount">Approved Amount: <i className="text-danger">*</i><span className="text-danger">{showHistoryApprovedAmountError ? "Amount required" : ""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="approved_amount" name="approved_amount" placeholder="Enter Amount"
                    onBlur={(e) => e.target.value == "" ? setShowHistoryApprovedAmountError(true) : setShowHistoryApprovedAmountError(false)}
                    onChange={(e) => setHistoryApprovedAmount(e.target.value)} value={historyApprovedAmount} disabled />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="approved_by">Approved By: <i className="text-danger">*</i><span className="text-danger">{showHistoryApprovedByError ? "Approved By required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="approved_by" onBlur={(e) => e.target.value == "" ? setShowHistoryApprovedByError(true) : setShowHistoryApprovedByError(false)}
                    onChange={(e) => setHistoryApprovedBy(e.target.value)} disabled>
                    <option value="" selected>Select Approved By</option>
                    {userList.map(user =>
                      <option value={user.id} selected={historyApprovedBy == user.id ? true : false}>{user.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="approval_date">Approval Date: <i className="text-danger">*</i><span className="text-danger">{showHistoryApprovalDateError ? "Date required" : ""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="approval_date" name="approval_date"
                    onBlur={(e) => e.target.value == "" ? setShowHistoryApprovalDateError(true) : setShowHistoryApprovalDateError(false)}
                    onChange={(e) => setHistoryApprovalDate(e.target.value)} value={historyApprovalDate} disabled />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="approval_notes">Approval Notes: </label>
                  <input type="text" class="form-control form-control-sm" id="approval_notes" name="approval_notes"
                    onChange={(e) => setHistoryApprovalNotes(e.target.value)} value={historyApprovalNotes} />
                </div>
              </div>

              <div className="row">
                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="repaired_marked_by">Repair Marked By: <i className="text-danger">*</i><span className="text-danger">{showHistoryRepairMarkedByError ? "RepairMarked By required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="repaired_marked_by" onBlur={(e) => e.target.value == "" ? setShowHistoryRepairMarkedByError(true) : setShowHistoryRepairMarkedByError(false)}
                    onChange={(e) => setHistoryRepairMarkedBy(e.target.value)} disabled>
                    <option value="" selected>Select Repair Marked By</option>
                    {userList.map(user =>
                      <option value={user.id} selected={historyRepairMarkedBy == user.id ? true : false}>{user.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="repair_date">Repair Date: <i className="text-danger">*</i><span className="text-danger">{showHistoryRepairDateError ? "Date required" : ""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="repair_date" name="repair_date"
                    onBlur={(e) => e.target.value == "" ? setShowHistoryRepairDateError(true) : setShowHistoryRepairDateError(false)}
                    onChange={(e) => setHistoryRepairDate(e.target.value)} value={historyRepairDate} disabled />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="repair_notes">Repair Notes: </label>
                  <input type="text" class="form-control form-control-sm" id="repair_notes" name="repair_notes"
                    onChange={(e) => setHistoryRepairNotes(e.target.value)} value={historyRepairNotes} />
                </div>
              </div>

              <div className="row">
                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="verified_by">Verified By: <i className="text-danger">*</i><span className="text-danger">{showHistoryVerifiedByError ? "Verified By required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="verified_by" onBlur={(e) => e.target.value == "" ? setShowHistoryVerifiedByError(true) : setShowHistoryVerifiedByError(false)}
                    onChange={(e) => setHistoryVerifiedBy(e.target.value)} disabled>
                    <option value="" selected>Select Verified By</option>
                    {userList.map(user =>
                      <option value={user.id} selected={historyVerifiedBy == user.id ? true : false}>{user.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="verification_date">Verification Date: <i className="text-danger">*</i><span className="text-danger">{showHistoryVerificationDateError ? "Date required" : ""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="verification_date" name="verification_date"
                    onBlur={(e) => e.target.value == "" ? setShowHistoryVerificationDateError(true) : setShowHistoryVerificationDateError(false)}
                    onChange={(e) => setHistoryVerificationDate(e.target.value)} value={historyVerificationDate} disabled />
                </div>

                <div class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label for="verification_notes">Verification Notes: </label>
                  <input type="text" class="form-control form-control-sm" id="verification_notes" name="verification_notes"
                    onChange={(e) => setHistoryVerificationNotes(e.target.value)} value={historyVerificationNotes} />
                </div>
              </div>
            </div>
          </form>

          <div>
            <h5 className="mt-3 mb-0">Damaged Parts</h5><hr className="my-2"></hr>
            <div className="col-12 text-left" style={{ marginTop: -5, zIndex: 100 }}>
              <DataTable
                columns={historydamagedpartcolumns}
                data={historyDamagedPartList}
                progressPending={dataPending}
                progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
                pagination
                highlightOnHover
                fixedHeader
                customStyles={userTableCustomStyles}
                dense
              />
            </div>

            <div className="row">
              <div className="col-6 text-left" style={{ marginTop: -5, zIndex: 100 }}>
                <DataTable
                  columns={historypartphotoscolumns}
                  data={historyDamagedPartPhotoList}
                  progressPending={dataPending}
                  progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                  noDataComponent={<p className="text-center pt-5">No Damaged Photos Found</p>}
                  pagination
                  highlightOnHover
                  fixedHeader
                  customStyles={userTableCustomStyles}
                  dense
                />
              </div>

              <div className="col-6 text-left" style={{ marginTop: -5, zIndex: 100 }}>
                <DataTable
                  columns={historypartphotoscolumns}
                  data={historyRepairedPartPhotoList}
                  progressPending={dataPending}
                  progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                  noDataComponent={<p className="text-center pt-5">No Repaired Photos Found</p>}
                  pagination
                  highlightOnHover
                  fixedHeader
                  customStyles={userTableCustomStyles}
                  dense
                />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal size="sm" show={showHistoryChatModal} onHide={handleHistoryChatModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Chat</Modal.Title>
        </Modal.Header>
        <Modal.Body>

        </Modal.Body>
      </Modal>

      {/* ----------------------------- History Section --------------------- */}
    </div>
  );
}

export default Container;
